<template>
  <div
    class="chat-container"
    v-title="onlineTitle"
  >
    <template v-if="isPc">
      <!--导航栏-->
      <div class="navbar-p-pc">
<!--        右上角标题-->
        <div class="navbar-p-pc-l">
          <div class="navbar-p-pc-l-title">{{ meetingDetail.title }}</div>
          <div class="navbar-p-pc-l-time">{{ meetingDetail.display_time }}</div>
        </div>
        <div class="navbar-p-pc-m">
          <!--自定义按钮-->
          <div
            v-if="customUrl && customImg && !showEmojiPanel"
            :class="[isPc ? 'customize-absolute-p-pc' : 'customize-absolute-p']"
            @click="customBtnClick"
          >
            <van-image
              :width="isPc?'0.7rem':'0.59rem'"
              :height="isPc?'0.7rem':'0.59rem'"
              :src="customImg"
            />
          </div>
          <!--登录或完善资料按钮-->
          <div
            v-if="(isActNeedLogin || isActNeedPerfect) && !showEmojiPanel"
            :class="[isPc ? 'logperfect-absolute-p-pc' : 'logperfect-absolute-p']"
            @click="logOrPerfect"
          >
            <van-image
              :width="isPc?'0.79rem':'0.59rem'"
              :height="isPc?'0.64rem':'0.48rem'"
              :src="isActNeedLogin?require('@/assets/imgs/login-icon.png'):require('@/assets/imgs/perfect-icon.png')"
            />
          </div>
          <!--预约按钮-->
          <div
            v-if="isShowAppoint && !showEmojiPanel && !isHasBranchMeet"
            :class="[isPc ? 'appoint-absolute-p-pc' : 'appoint-absolute-p']"
            @click="makeAppoint"
          >
            <van-image
              :width="isPc?'0.75rem':'0.6rem'"
              :height="isPc?'0.75rem':'0.6rem'"
              :src="require('@/assets/imgs/appoint.png')"
            />
          </div>
          <!--抽奖按钮-->
          <drawButton
            ref="drawBtn"
            :canShow="!showEmojiPanel"
            @login="drawLogin"
            @register="drawRegister"
            @draw="showDrawPanel"
          ></drawButton>
        </div>
        <div class="navbar-p-pc-r">
          <div class="navbar-p-pc-r-num">
            <onlineNum :people="onlineNumber"></onlineNum>
          </div>
          <div class="navbar-p-pc-r-phone">
            <el-popover
              placement="bottom"
              width="200"
              :offset="50"
              trigger="hover">
              <canvas id="qrcode" style="width: 100%;height:100%;"/>
              <div style="text-align:center;font-size:0.18rem;">{{content.scanWx}}</div>
              <div slot="reference" class="phone-desc"><van-icon name="graphic" />{{content.widthMobile}}</div>
            </el-popover>
          </div>
          <div class="navbar-p-pc-r-tel">
            <van-icon name="phone" />4008-554-120
          </div>
          <div class="navbar-p-pc-r-avator">
            <el-dropdown v-if="!isActNeedLogin">
              <van-image
                width="0.5rem"
                height="0.5rem"
                round
                fit="cover"
                :loading-icon="'manager-o'"
                :src="userInfo && userInfo.avatar ? userInfo.avatar : null"
              />
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-user" @click.native="pcMineInfo">{{ content.mineTitle }}</el-dropdown-item>
                <el-dropdown-item icon="el-icon-warning-outline" @click.native="pcFeedback">{{ content.feedback }}</el-dropdown-item>
                <el-dropdown-item icon="el-icon-switch-button" @click.native="pcLogoutClick">{{ content.mineLogout }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <van-image
              v-else
              width="0.5rem"
              height="0.5rem"
              round
              fit="cover"
              :loading-icon="'manager-o'"
              :src="null"
              @click="avatarClick"
            />
            <!-- <van-image
              width="0.5rem"
              height="0.5rem"
              round
              fit="cover"
              :loading-icon="'manager-o'"
              :src="userInfo && userInfo.avatar ? userInfo.avatar : null"
            /> -->
          </div>
        </div>
      </div>
      <div class="body-pc">
        <div class="body-pc-l">
          <div
            class="all"
          >
            <div style="width:100%;height:100%;"
              v-if="dataInfo.replay_is_open == 0 && ((live_status == 'IN_HAND' && !isPlayError) || (isLiveTime && !isPlayError))">
              <video
                :id="'player-container-id'+streamId"
                :key="'live'"
                style="width:100%;height:100%;"
                preload="auto" playsinline webkit-playsinline x5-playsinline
              ></video>
            </div>
            <img
              v-else-if="live_status == 'NOT_STARTED'"
              class="all-content"
              :src="dataInfo.cover_url||meetingDetail.detail_cover_url"
            >
            <img
              v-else-if="(live_status == 'ENDED' && historyUrl == '') || (live_status == 'IN_HAND' && isPlayError && historyUrl == '')"
              class="all-content"
              :src="dataInfo.cover_url||meetingDetail.detail_cover_url"
            >
<!--            点播回放-->
            <video
              v-else-if="historyUrl != ''"
              :key="'back'"
              :src="historyUrl"
              class="all-content"
              autoplay
              controls
              controlslist="nodownload noremoteplayback"
              ref="historyRef"
            ></video>
            <img
              v-else
              class="all-content"
              :src="dataInfo.cover_url||meetingDetail.detail_cover_url"
            >
            <div v-if="countDTime > 0" class="not-start">
              <div class="count-title"></div>
              <!-- <div class="count-title">{{content.countdown}}：</div> -->
              <van-count-down :time="countDTime">
                <template #default="timeData">
                  <div class="block-p">
                    <div class="block">{{ timeData.days | addZero }}</div>
                    <!-- <div class="unit">天</div> -->
                  </div>
                  <div class="colon">{{content.dd}}</div>
                  <div class="block-p">
                    <div class="block">{{ timeData.hours | addZero }}</div>
                    <!-- <div class="unit">时</div> -->
                  </div>
                  <div class="colon">{{content.hh}}</div>
                  <div class="block-p">
                    <div class="block">{{ timeData.minutes | addZero }}</div>
                    <!-- <div class="unit">分</div> -->
                  </div>
                  <div class="colon">{{content.mm}}</div>
                  <div class="block-p">
                    <div class="block">{{ timeData.seconds | addZero }}</div>
                    <!-- <div class="unit">秒</div> -->
                  </div>
                  <div class="colon">{{content.ss}}</div>
                </template>
              </van-count-down>
            </div>
          </div>
          <!--问卷调查-->
          <!-- <div
            class="Q-A-panel"
            :class="{'show-my-question':showQA}"
          >
            <div class="Q-A-p">
              <div class="Q-A-close-btn" @click="showQA=false">
                <van-icon name="close" size="0.24rem" color="#FFF"/>
              </div>
              <div class="Q-A-body">
                <div class="Q-A-question">{{questionInfo.title}}</div>
                <div class="Q-A-answer">
                  <van-button v-for="answerItem in questionInfo.answers" :key="answerItem" type="info" plain :class="{active:myQAanswer==answerItem}" @click="answerMyQuestion(answerItem)">{{answerItem}}</van-button>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="body-pc-r">
          <div
            v-if="streamId != ''"
            class="chat-panel-pc"
            :style="{height: $route.query.conventionId?`calc(100% - 3.41rem - ${roomInfoPanelHeight}px)`:`calc(100% - 2.81rem - ${roomInfoPanelHeight}px)`}"
          >
            <div class="chat-tool-panel">
              <div
                :class="[activeIndex =='1'?'active':'','chat-tool']"
                :style="{width: chatToolWidth}"
                @click="change('1')"
              >{{ detailAlias }}</div>
              <div
                v-if="isHasDuration"
                :class="[activeIndex =='2'?'active':'','chat-tool']"
                :style="{width: chatToolWidth}"
                @click="change('2')"
              >{{ durationAlias }}</div>



              <!-- 目录  -->
              <div
                v-if="isHasContent"
                :class="[activeIndex =='6'?'active':'','chat-tool']"
                :style="{width: chatToolWidth}"
                @click="change('6')"
              >{{ contentAlias }}</div>

              <!-- 添加 10正在直播&11往期回放-->
              <div
                  v-if="isLiveCont && $route.query.live_meeting_id == '2226'"
                  :class="[activeIndex =='10'?'active':'','chat-tool']"
                  :style="{width: chatToolWidth}"
                  @click="change('10')"
              >正在直播</div>

              <div
                  v-if="isBackwardReplay && $route.query.live_meeting_id == '2226'"
                  :class="[activeIndex =='11'?'active':'','chat-tool']"
                  :style="{width: chatToolWidth}"
                  @click="change('11')"
              >往期回放</div>

              <div
                v-if="isHasBackPlay"
                :class="[activeIndex =='3'?'active':'','chat-tool']"
                :style="{width: chatToolWidth}"
                @click="change('3')"
              >{{content.backPlay}}</div>
              <div
                v-if="isHasBranchMeet"
                :class="[activeIndex =='8'?'active':'','chat-tool']"
                :style="{width: chatToolWidth}"
                @click="change('8')"
              >{{ branchMeetAlias }}</div>
              <div
                v-if="isHasDiscuss"
                :class="[activeIndex =='4'?'active':'','chat-tool']"
                :style="{width: chatToolWidth}"
                @click="change('4')"
              >{{ discussAlias }}</div>
              <div
                v-if="isHasCloudHall"
                :class="[activeIndex =='5'?'active':'','chat-tool']"
                :style="{width: chatToolWidth}"
                @click="change('5')"
              >{{ cloudHallAlias }}</div>
              <div
                v-if="isHasEnterprise"
                :class="[activeIndex =='7'?'active':'','chat-tool']"
                :style="{width: chatToolWidth}"
                @click="change('7')"
              >{{ enterpriseAlias }}</div>
              <div
                v-if="isHasGuess"
                :class="[activeIndex =='9'?'active':'','chat-tool']"
                :style="{width: chatToolWidth}"
                @click="change('9')"
              >{{ content.awardQA }}</div>
            </div>
            <div
              class="chat-p-panel"
              :style="{
                transform: chatPanelTransform,
                width: chatTotalPanelWidth}"
            >
              <!--详情面板-->
              <div
                class="chat-syllabus beauty-scroll"
                :style="{width:chatPanelWidth}"
              >
                <img :src="dataInfo.desc_image_url||meetingDetail.desc_image_url">
              </div>
              <!--时长面板-->
              <div
                v-if="isHasDuration"
                :style="{width:chatPanelWidth}"
                class="chat-duration  beauty-scroll"
              >
                <durationPanel
                  ref="durationPanel"
                  :dataInfo="durationInfo"
                  :conventionId="this.$route.query.conventionId ? Number(this.$route.query.conventionId) : null"
                  :liveType="(live_status=='IN_HAND'&&historyUrl=='')?'LIVE':(live_status=='ENDED'||historyUrl!='')?'VOD':''"
                  :streamId="streamId"
                  :memberId="memberId"
                  :durationRemark="durationRemark"
                  :requiredViewingTime="requiredViewingTime"
                  :actualViewingTime="actualViewingTime"
                  :viewingType="viewingType"
                  @reportSuccess="reportSuccess"
                ></durationPanel>
              </div>
             
            
              <!--目录面板-->
              <!--将会议id  live_meeting_id=2226  目录分为 : 直播和回放-->

              <!--目录面板-->
              <div
                  v-if="isHasContent"
                  :style="{width:chatPanelWidth}"
                  class="chat-content"
              >
                <contentPanel
                    ref="contentPanel"
                    :contentObj="meetingDetail"
                    :streamId="streamId"
                    :videoId="videoId"
                    :liveType="'all'"
                    @watchVideo="watchVideo"
                    @exchangeLive="contentExchangeLive"
                ></contentPanel>
              </div>


              <!--目录--直播面板-->
              <div
                  v-if="isLiveCont"
                  :style="{width:chatPanelWidth}"
                  class="chat-content"
              >
                <contentPanel
                    ref="contentPanel"
                    :contentObj="meetingDetail"
                    :streamId="streamId"
                    :videoId="videoId"
                    :liveType="'video'"
                    @watchVideo="watchVideo"
                    @exchangeLive="contentExchangeLive"
                ></contentPanel>
              </div>

              <!--目录--回放面板-->
              <div
                  v-if="isBackwardReplay"
                  :style="{width:chatPanelWidth}"
                  class="chat-content"
              >
                <contentPanel
                    ref="contentPanel"
                    :contentObj="meetingDetail"
                    :streamId="streamId"
                    :videoId="videoId"
                    :liveType="'live'"
                    @watchVideo="watchVideo"
                    @exchangeLive="contentExchangeLive"
                ></contentPanel>
              </div>


              <!--回放面板-->
              <div
                v-if="isHasBackPlay"
                class="chat-backplay beauty-scroll"
                :style="{width:chatPanelWidth}"
              >
                <div
                  v-for="(item,index) in dataInfo.video_data"
                  :key="index"
                  class="backplay-item"
                  :class="['backplay-item', historyActiveIndex==index?'active':'']"
                  @click="showHistory(item, index)"
                >
                  <van-icon
                    name="play-circle-o"
                    size="0.24rem"
                  />
                  <div class="backplay-title van-multi-ellipsis--l2">{{item.title}}</div>
                </div>
              </div>



              <!--分会场面板-->
              <div
                v-if="isHasBranchMeet"
                class="chat-branchmeet"
                :style="{width:chatPanelWidth}"
              >
                <branchMeet :dateList="conventionDateList" :conventionId="Number($route.query.conventionId)" :defaultDate="branchMeetDefaultDate" :defaultSite="branchMeetDefaultSite"></branchMeet>
              </div>
               
              <!--讨论面板-->
              <div
                v-if="isHasDiscuss && activeIndex === '4'"
                class="chat-p"
                :style="{width:chatPanelWidth}"
              >
                <chatList
                  :list="list"
                  class="chat-list"
                ></chatList>
                <div class="chat-input">
                  <van-search
                    left-icon=""
                    v-model="chatValue"
                    :clearable="false"
                  />
                  <!-- <van-icon name="smile-o" />
                  <van-icon
                    name="add-o"
                    v-if="chatValue == ''"
                  /> -->
                  <van-button
                    type="info"
                    class="add-btn"
                    @click="search"
                  >{{content.send}}</van-button>
                </div>
              </div>
              <!--展厅面板-->
              <div
                v-if="isHasCloudHall"
                class="chat-cloudHall beauty-scroll"
                :style="{width:chatPanelWidth}"
              >
                <div
                  v-for="item in cloudHalls"
                  :key="item.id"
                  class="cloudHall-item"
                  @click="goCloudHall(item)"
                >
                  <img :src="item.display_url">
                  <div class="title">{{item.title}}</div>
                </div>
              </div>
               <!--企业专区面板-->
                <div
                 v-if="isHasEnterprise"
                class="chat-enterprise  beauty-scroll"
                :style="{width:chatPanelWidth}"
              >
                <img :src="dataInfo.enterprise_image[0]" >
                 </div>
              <!-- <div
                v-if="isHasEnterprise"
                class="chat-cloudHall beauty-scroll"
                :style="{width:chatPanelWidth}"
              >
              <div
                  v-for="(item,index) in dataInfo.enterprise_image"
                  :key="index"
                  class="cloudHall-item"
                
                >
                  <img :src="item" />
                 
                </div>
               
              </div> -->
              
              <!--有奖竞答-->
              <div
                v-if="isHasGuess"
                :style="{width:chatPanelWidth}"
                class="chat-content"
              >
                <guessPanel
                  ref="guessPanel"
                  :streamId="streamId"
                ></guessPanel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>





    <template v-else>
      <!--导航栏-->
      <div
        class="navbar-p"
        v-if="$route.query.conventionId"
      >
        <div
          class="left-btn"
          @click="leftBtn"
        >
          <van-icon name="arrow-left" />
          <div>{{content.back}}</div>
        </div>
        <div
          class="right-btn"
          @click="rightBtn"
        >
          <van-icon
            name="wap-home"
            size="0.25rem"
            color="#FFF"
          />
        </div>
      </div>
      <!--播放区域-->
      <div class="online-link">
        <div
          class="all"
        >
          <div style="width:100%;height:100%;"
            v-if="dataInfo.replay_is_open == 0 && ((live_status == 'IN_HAND' && !isPlayError) || (isLiveTime && !isPlayError))">
            <video
              :id="'player-container-id'+streamId"
              :key="'live'"
              style="width:100%;height:100%;"
              preload="auto" playsinline webkit-playsinline x5-playsinline
            ></video>
          </div>
          <img
            v-else-if="live_status == 'NOT_STARTED'"
            class="all-content"
            :src="dataInfo.cover_url||meetingDetail.detail_cover_url"
          >
          <img
            v-else-if="(live_status == 'ENDED' && historyUrl == '') || (live_status == 'IN_HAND' && isPlayError && historyUrl == '')"
            class="all-content"
            :src="dataInfo.cover_url||meetingDetail.detail_cover_url"
          >
          <video
            v-else-if="historyUrl != ''"
            :key="'back'"
            :src="historyUrl"
            class="all-content"
            autoplay
            controls
            controlslist="nodownload noremoteplayback"
            ref="historyRef"
          ></video>
          <img
            v-else
            class="all-content"
            :src="dataInfo.cover_url||meetingDetail.detail_cover_url"
          >
          <div v-if="countDTime > 0" class="not-start">
            <div class="count-title"></div>
            <!-- <div class="count-title">{{content.countdown}}：</div> -->
            <van-count-down :time="countDTime">
              <template #default="timeData">
                <div class="block-p">
                  <div class="block">{{ timeData.days | addZero }}</div>
                  <!-- <div class="unit">天</div> -->
                </div>
                <div class="colon">{{content.dd}}</div>
                <div class="block-p">
                  <div class="block">{{ timeData.hours | addZero }}</div>
                  <!-- <div class="unit">时</div> -->
                </div>
                <div class="colon">{{content.hh}}</div>
                <div class="block-p">
                  <div class="block">{{ timeData.minutes | addZero }}</div>
                  <!-- <div class="unit">分</div> -->
                </div>
                <div class="colon">{{content.mm}}</div>
                <div class="block-p">
                  <div class="block">{{ timeData.seconds | addZero }}</div>
                  <!-- <div class="unit">秒</div> -->
                </div>
                <div class="colon">{{content.ss}}</div>
              </template>
            </van-count-down>
          </div>
        </div>
        <!--问卷调查-->
        <!--<div
          class="Q-A-panel"
          :class="{'show-my-question':showQA}"
        >
          <div class="Q-A-p">
            <div class="Q-A-close-btn" @click="showQA=false">
              <van-icon name="close" size="0.24rem" color="#FFF"/>
            </div>
            <div class="Q-A-body">
              <div class="Q-A-question">{{questionInfo.title}}</div>
              <div class="Q-A-answer">
                <van-button v-for="answerItem in questionInfo.answers" :key="answerItem" type="info" plain :class="{active:myQAanswer==answerItem}" @click="answerMyQuestion(answerItem)">{{answerItem}}</van-button>
              </div>
            </div>
          </div>
        </div>-->
      </div>
      <!-- <div
        class="history-contain"
        v-if="live_status == 'ENDED'"
      >
        <div
          class="history-panel"
          v-if="dataInfo.video_data.length > 0"
        >
          <div
            v-for="(item,index) in dataInfo.video_data"
            :key="index"
            class="history-item"
            @click="showHistory(item)"
          >
            <van-icon name="play-circle" />
            <div class="his-desc">分段{{index + 1}}</div>
          </div>
        </div>
        <div
          v-if="dataInfo.video_data.length == 0"
          class="history-empty"
        >暂无回放</div>
      </div> -->
      <!--直播名称和时间-->
      <div
        class="room-info-panel"
        ref="roomInfoPanel"
      >
        <div class="room-info-title">{{meetingDetail.title}}</div>
        <div class="room-info-other">
          <div class="room-other-time">{{meetingDetail.display_time}}</div>
          <div class="room-other-online">
            <onlineNum :people="onlineNumber"></onlineNum>
          </div>
        </div>
      </div>
      <!--操作区域-->
      <div
        v-if="streamId != ''"
        class="chat-panel"
        :style="{height: $route.query.conventionId?`calc(100% - 3.41rem - ${roomInfoPanelHeight}px)`:`calc(100% - 2.81rem - ${roomInfoPanelHeight}px)`}"
      >
        <div class="chat-tool-panel">
          <div
            :class="[activeIndex =='1'?'active':'','chat-tool']"
            :style="{width: chatToolWidth}"
            @click="change('1')"
          >{{ detailAlias }}</div>
          <div
            v-if="isHasDuration"
            :class="[activeIndex =='2'?'active':'','chat-tool']"
            :style="{width: chatToolWidth}"
            @click="change('2')"
          >{{durationAlias}}</div>
          <div
            v-if="isHasContent"
            :class="[activeIndex =='6'?'active':'','chat-tool']"
            :style="{width: chatToolWidth}"
            @click="change('6')"
          >{{ contentAlias }}</div>


          <!-- 添加 10正在直播&11往期回放-->
          <div
              v-if="isLiveCont && $route.query.live_meeting_id == '2226'"
              :class="[activeIndex =='10'?'active':'','chat-tool']"
              :style="{width: chatToolWidth}"
              @click="change('10')"
          >正在直播</div>

          <div
              v-if="isBackwardReplay && $route.query.live_meeting_id == '2226'"
              :class="[activeIndex =='11'?'active':'','chat-tool']"
              :style="{width: chatToolWidth}"
              @click="change('11')"
          >往期回放</div>


          <div
            v-if="isHasBackPlay"
            :class="[activeIndex =='3'?'active':'','chat-tool']"
            :style="{width: chatToolWidth}"
            @click="change('3')"
          >{{content.backPlay}}</div>
          <div
            v-if="isHasBranchMeet"
            :class="[activeIndex =='8'?'active':'','chat-tool']"
            :style="{width: chatToolWidth}"
            @click="change('8')"
          >{{ branchMeetAlias }}</div>
          <div
            v-if="isHasDiscuss"
            :class="[activeIndex =='4'?'active':'','chat-tool']"
            :style="{width: chatToolWidth}"
            @click="change('4')"
          >{{ discussAlias }}</div>
          <div
            v-if="isHasCloudHall"
            :class="[activeIndex =='5'?'active':'','chat-tool']"
            :style="{width: chatToolWidth}"
            @click="change('5')"
          >{{ cloudHallAlias }}</div>
          <div
            v-if="isHasEnterprise"
            :class="[activeIndex =='7'?'active':'','chat-tool']"
            :style="{width: chatToolWidth}"
            @click="change('7')"
          >{{ enterpriseAlias }}</div>
          <div
            v-if="isHasGuess"
            :class="[activeIndex =='9'?'active':'','chat-tool']"
            :style="{width: chatToolWidth}"
            @click="change('9')"
          >{{ content.awardQA }}</div>
        </div>
        <div
          class="chat-p-panel"
          :style="{
            transform: chatPanelTransform,
            width: chatTotalPanelWidth}"
        >
          <!--详情面板-->
          <div
            class="chat-syllabus"
            :style="{width:chatPanelWidth}"
          >
            <img :src="dataInfo.desc_image_url||meetingDetail.desc_image_url">
          </div>
          <!--时长面板-->
          <div
            v-if="isHasDuration"
            :style="{width:chatPanelWidth}"
            class="chat-duration"
          >
            <durationPanel
              ref="durationPanel"
              :dataInfo="durationInfo"
              :conventionId="this.$route.query.conventionId ? Number(this.$route.query.conventionId) : null"
              :liveType="(live_status=='IN_HAND'&&historyUrl=='')?'LIVE':(live_status=='ENDED'||historyUrl!='')?'VOD':''"
              :streamId="streamId"
              :memberId="memberId"
              :durationRemark="durationRemark"
              :requiredViewingTime="requiredViewingTime"
              :actualViewingTime="actualViewingTime"
              :viewingType="viewingType"
              @reportSuccess="reportSuccess"
            ></durationPanel>
          </div>
          <!--目录面板-->
          <div
            v-if="isHasContent"
            :style="{width:chatPanelWidth}"
            class="chat-content"
          >
            <contentPanel
              ref="contentPanel"
              :contentObj="meetingDetail"
              :streamId="streamId"
              :videoId="videoId"
              :liveType="'all'"
              @watchVideo="watchVideo"
              @exchangeLive="contentExchangeLive"
            ></contentPanel>
          </div>


          <!--目录--直播面板-->
          <div
              v-if="isLiveCont"
              :style="{width:chatPanelWidth}"
              class="chat-content"
          >
            <contentPanel
                ref="contentPanel"
                :contentObj="meetingDetail"
                :streamId="streamId"
                :videoId="videoId"
                :liveType="'video'"
                @watchVideo="watchVideo"
                @exchangeLive="contentExchangeLive"
            ></contentPanel>
          </div>

          <!--目录--回放面板-->
          <div
              v-if="isBackwardReplay"
              :style="{width:chatPanelWidth}"
              class="chat-content"
          >
            <contentPanel
                ref="contentPanel"
                :contentObj="meetingDetail"
                :streamId="streamId"
                :videoId="videoId"
                :liveType="'live'"
                @watchVideo="watchVideo"
                @exchangeLive="contentExchangeLive"
            ></contentPanel>
          </div>



          <!--回放面板-->
          <div
            v-if="isHasBackPlay"
            class="chat-backplay"
            :style="{width:chatPanelWidth}"
          >
            <div
              v-for="(item,index) in dataInfo.video_data"
              :key="index"
              class="backplay-item"
              :class="['backplay-item', historyActiveIndex==index?'active':'']"
              @click="showHistory(item, index)"
            >
              <van-icon
                name="play-circle-o"
                size="0.24rem"
              />
              <div class="backplay-title van-multi-ellipsis--l2">{{item.title}}</div>
            </div>
          </div>
          <!--分会场面板-->
          <div
            v-if="isHasBranchMeet"
            class="chat-branchmeet"
            :style="{width:chatPanelWidth}"
          >
            <branchMeet :dateList="conventionDateList" :conventionId="Number($route.query.conventionId)" :defaultDate="branchMeetDefaultDate" :defaultSite="branchMeetDefaultSite"></branchMeet>
          </div>
          <!--讨论面板-->
          <div
            v-if="isHasDiscuss"
            class="chat-p"
            :style="{width:chatPanelWidth}"
          >
            <chatList
              :list="list"
              :style="{height: `calc(100% - ${customInputHeight}px)`}"
              class="chat-list"
              @click="showEmojiPanel = false"
            ></chatList>
            <!-- <div class="chat-input-p" ref="chatInputP">
              <div class="chat-input">
                <customInput ref="customInput" v-model="chatValue"></customInput>
                <van-icon name="smile-o" @click.stop="showEmojiPanel = !showEmojiPanel"/>
                <van-button
                  v-if="chatValue !== '' && chatValue !== '<div><br></div>'"
                  type="info"
                  class="add-btn"
                  @click="search"
                >{{content.send}}</van-button>
                <van-icon
                  v-else
                  name="add-o"
                  @click="feedbackShow=true"
                />
              </div>
            </div> -->
            <div class="chat-input-p" ref="chatInputP">
              <div class="chat-input">
                <van-image round width="0.45rem" height="0.45rem" fit="cover" :src="userInfo && userInfo.avatar ? userInfo.avatar : null" :loading-icon="'manager-o'" class="chat-avatar" @click="avatarClick"/>
                <customInput ref="customInput" v-model="chatValue" ></customInput>
                <van-icon name="smile-o" @click.stop="showEmojiPanel = !showEmojiPanel"/>
                <van-button
                  v-if="chatValue !== '' && chatValue !== '<div><br></div>'"
                  type="info"
                  class="add-btn"
                  @click="search"
                >{{content.send}}</van-button>
                <van-icon
                  v-else-if="lanuage == 'Chinese'"
                  name="add-o"
                  @click="feedbackShow=true"
                />
              </div>
              <div v-if="showEmojiPanel" class="emoji-list-p" >
                <div class="emoji-list">
                  <div v-for="(item, index) in emojiList" :key="index" class="emoji-item" :style="{width: isPc?'0.57rem':'0.59rem',height: isPc?'0.57rem':'0.59rem'}" @click="addEmoji(item)">{{ item }}</div>
                </div>
              </div>
            </div>
          </div>
          <!--展厅面板-->
          <div
            v-if="isHasCloudHall"
            class="chat-cloudHall"
            :style="{width:chatPanelWidth}"
          >
            <div
              v-for="item in cloudHalls"
              :key="item.id"
              class="cloudHall-item"
              @click="goCloudHall(item)"
            >
              <img :src="item.display_url">
              <div class="title">{{item.title}}</div>
            </div>
          </div>
          <!--企业专区面板-->
          <div
            v-if="isHasEnterprise"
            class="chat-enterprise"
            :style="{width:chatPanelWidth}"
          
          >
            <img :src="dataInfo.enterprise_image[0]" />
          </div>
          <!--有奖竞答-->
          <div
            v-if="isHasGuess"
            :style="{width:chatPanelWidth}"
            class="chat-content"
          >
            <guessPanel
              ref="guessPanel"
              :streamId="streamId"
            ></guessPanel>
          </div>
        </div>
      </div>
    </template>
    <!-- 完善资料 -->
    <perfectDialog
        v-if="perfectDialogIsShow"
      ref="perfectDialog"
      :dataForm="perfectForm"
      :phone="perfectForm.phone"
      :canClose="true"
      @perfectSuccess="perfectSuccess"
    ></perfectDialog>
    <!--悬浮按钮-->
    <div
      class="absolute-p"
      @click="sharePopupShow=true"
    >
      <van-image
        width="0.58rem"
        height="0.58rem"
        round
        :src="require('@/assets/imgs/popup-btn.png')"
      />
    </div>
    <!--自定义按钮-->
    <div
      v-if="!isPc && customUrl && customImg && !showEmojiPanel"
      :class="[isPc ? 'customize-absolute-p-pc' : 'customize-absolute-p']"
      :style="{transform: `translateY(${isPc ? '0' : ((isActNeedLogin || isActNeedPerfect) && isShowAppoint ? '-1.6rem' : (isActNeedLogin || isActNeedPerfect) || isShowAppoint ? '-0.8rem' : '0')})`}"
      @click="customBtnClick"
    >
      <van-image
        :width="isPc?'0.7rem':'0.59rem'"
        :height="isPc?'0.7rem':'0.59rem'"
        :src="customImg"
      />
    </div>
    <!--登录或完善资料按钮-->
    <div
      v-if="!isPc && (isActNeedLogin || isActNeedPerfect) && !showEmojiPanel"
      :class="[isPc ? 'logperfect-absolute-p-pc' : 'logperfect-absolute-p']"
      :style="{transform: `translateY(${isPc ? '0' : isShowAppoint ? '-0.8rem' : '0'})`}"
      @click="logOrPerfect"
    >
      <van-image
        :width="isPc?'0.79rem':'0.59rem'"
        :height="isPc?'0.64rem':'0.48rem'"
        :src="isActNeedLogin?require('@/assets/imgs/login-icon.png'):require('@/assets/imgs/perfect-icon.png')"
      />
    </div>
    <!--预约按钮-->
    <div
      v-if="!isPc && isShowAppoint && !showEmojiPanel && !isHasBranchMeet"
      :class="[isPc ? 'appoint-absolute-p-pc' : 'appoint-absolute-p']"
      @click="makeAppoint"
    >
      <van-image
        :width="isPc?'0.75rem':'0.6rem'"
        :height="isPc?'0.75rem':'0.6rem'"
        :src="require('@/assets/imgs/appoint.png')"
      />
    </div>
    <!--抽奖按钮-->
    <drawButton
      ref="drawBtn"
      v-if="!isPc"
      :canShow="!showEmojiPanel"
      @login="drawLogin"
      @register="drawRegister"
      @draw="showDrawPanel"
    ></drawButton>
    <!--抽奖面板-->
    <lotteryDraw
      ref="lotteryDraw"
      @success="drawSuccess"
      @fail="drawFail"
    ></lotteryDraw>
    <!--抽奖抽中面板-->
    <drawSuccessDialog ref="drawSuccessDialog"></drawSuccessDialog>
    <!--抽奖未中面板-->
    <drawFailDialog ref="drawFailDialog"></drawFailDialog>
    <!--扫描二维码-->
    <van-popup
      v-model="sharePopupShow"
      position="bottom"
      closeable
      close-icon="close"
      :close-on-click-overlay="false"
      class="share-popup"
      :style="{background:`url(${require('@/assets/imgs/popup-bg.png')}) no-repeat center center`,backgroundSize: '4.2rem 4.17rem'}"
    >
      <div class="share-p">
        <div class="share-title">长按专注更多云ICU平台会议信息</div>
        <van-image
          width="2.75rem"
          height="2.75rem"
          :src="require('@/assets/imgs/popup-cont.png')"
        />
      </div>
    </van-popup>
    <!-- 登录弹框 -->
    <loginDialog
      ref="loginDialog"
      :streamId="Number(streamId)"
      :canClose="true"
      @needRegister="needRegister"
      @loginSuccess="loginSuccess"
      @loginFail="loginFail"
      @visitorLogin="visitorLogin"
      @lookPolicy="lookPolicy"
    ></loginDialog>
    <!-- 邮箱验证码登录弹框 -->
    <emailLoginDialog
      ref="emailLoginDialog"
      :streamId="Number(streamId)"
      :canClose="true"
      @loginSuccess="loginSuccess"
      @loginFail="emailLoginFail"
      @visitorLogin="visitorLogin"
      @lookPolicy="lookPolicy"
    ></emailLoginDialog>
    <!-- 隐私条款 -->
    <policyDialog
      ref="policyDialog"
      :room="streamId"
    ></policyDialog>
    <!--提示登录-->
    <van-popup
      v-model="loginPopupShow"
      position="bottom"
      closeable
      close-icon="close"
      :overlay="false"
      :close-on-click-overlay="false"
      :class="[isPc?'login-popup-pc':'login-popup']"
    >
      <div class="login-popup-p">
        <div class="login-tip">{{loginTip}}</div>
        <van-button
          type="info"
          class="login-btn"
          @click="loginPopup"
        >{{content.toLogin}}</van-button>
      </div>
    </van-popup>
    <!--合作咨询、意见反馈、投诉-->
    <van-popup
      v-model="feedbackShow"
      position="bottom"
      get-container="#app"
      safe-area-inset-bottom
      style="background-color:#F4F4F4;border-top-left-radius: 0.07rem;border-top-right-radius: 0.07rem;"
    >
      <div class="feedback-popup-p">
        <div class="feedback-title">{{ content.more }}</div>
        <div class="feedback-body">
          <a class="feedback-item" href="tel:4008-554-120">
            <div class="feedback-item-img-p">
              <img :src="require('@/assets/imgs/cooperate.png')" class="feedback-item-img">
            </div>
            <div class="feedback-item-desc">{{ content.consult }}</div>
          </a>
          <div class="feedback-item" @click="feedback">
            <div class="feedback-item-img-p">
              <img :src="require('@/assets/imgs/feedback.png')" class="feedback-item-img">
            </div>
            <div class="feedback-item-desc">{{ content.feedback }}</div>
          </div>
          <div class="feedback-item" @click="complain">
            <div class="feedback-item-img-p">
              <img :src="require('@/assets/imgs/complain.png')" class="feedback-item-img">
            </div>
            <div class="feedback-item-desc">{{ content.complain }}</div>
          </div>
          <div class="feedback-item" @click="mine">
            <div class="feedback-item-img-p">
              <img :src="require('@/assets/imgs/mine.png')" class="feedback-item-img">
            </div>
            <div class="feedback-item-desc">{{ content.mineTitle }}</div>
          </div>
        </div>
        <div class="feedback-cancel" @click="feedbackShow=false">{{ content.becancel }}</div>
      </div>
    </van-popup>
    <!-- 我的资料 -->
    <pcMine v-if="pcMineIsShow" ref="pcMine" :canClose="true"/>
    <!-- 意见反馈 -->
    <pcFeedback ref="pcFeedback" :memberId="memberId" :canClose="true"/>
    <!-- pc端有奖竞猜 -->
    <pcGuess ref="pcGuess" :liveMettingId="$route.query.live_meeting_id ? Number($route.query.live_meeting_id) : null" :liveStreamId="Number(streamId)" :memberId="memberId" :canClose="true"/>
    <!-- 移动端有奖竞猜 -->
    <mobileGuess ref="mobileGuess" :liveMettingId="$route.query.live_meeting_id ? Number($route.query.live_meeting_id) : null" :liveStreamId="Number(streamId)" :memberId="memberId" :canClose="true"/>
    <!-- 退出登录确认 -->
    <logoutDialog ref="logoutDialog" @logout="logout"/>
  </div>
</template>

<script>
import TCPlayer from 'tcplayer.js';
import onlineNum from './components/online-num'
import chatList from './components/chat-list'
import durationPanel from './components/duration-panel'
import contentPanel from './components/content-panel'
import guessPanel from './components/guess-panel'
import { postLiveMeetDetail, postUserInfo, postAddWatchRecord, postMettingDetail, postAddSubscribeRecord, postAddQuestionAnswer, getConventionDetail } from '@/models/common'
import perfectDialog from '@/views/home/components/perfect-dialog'
import loginDialog from '@/views/home/components/login-dialog'
import emailLoginDialog from '@/views/home/components/email-login-dialog'
import policyDialog from '@/views/home/components/policy-dialog'
import logoutDialog from '@/views/home/components/logout-dialog'
import drawButton from './components/draw-button'
import branchMeet from './components/branch-meet'
import lotteryDraw from '@/components/lotteryDraw'
import drawSuccessDialog from './components/lottery-draw/success.vue'
import drawFailDialog from './components/lottery-draw/fail.vue'
import customInput from '@/components/input.vue'
import pcFeedback from './components/pc/pc-feedback.vue'
import pcMine from './components/pc/pc-mine.vue'
import pcGuess from './components/pc/pc-guess.vue'
import mobileGuess from './components/guess-dialog.vue'
// import cryptoJs from 'crypto-js'
import Vue from "vue";
import QRCode from 'qrcode'
import VueSocketIO from 'vue-socket.io'
import { config } from "@/config";
import { dateFormat } from '@/utils/util'
import { mapState } from 'vuex'

import axios from "axios";
export default {
  components: {
    onlineNum, chatList, durationPanel, contentPanel, perfectDialog, loginDialog, policyDialog, logoutDialog,
    drawButton, branchMeet, lotteryDraw, drawSuccessDialog, drawFailDialog, emailLoginDialog, customInput,
    pcFeedback, pcMine, pcGuess, mobileGuess, guessPanel
  },
  filters: {
    addZero(val) {
      return val > 9 ? val : ('0' + val)
    }
  },
  data() {
    return {
      onlineTitle: '', // 网页标题
      activeIndex: '1', // 1详情 2时长 6目录 3回放 4讨论 5展厅 7企业专区   冯添加 10正在直播&11往期回放
      list: [],
      chatValue: '',
      onlineNumber: 0, // 在线人数
      live_status: '', // 直播状态
      historyUrl: '', // 已结束回放视频
      historyActiveIndex: -1, // 选择回放的下标
      dataInfo: {
        cover_url: '',
        created_time: '',
        desc_image_url: '',
        end_time: '',
        login_type: '',
        id: '',
        live_desc: '',
        live_status: '',
        pull_flv_ip: '',
        pull_m3u8_ip: '',
        pull_rtmp_ip: '',
        pull_udp_ip: '',
        live_start_time: '',
        start_time: '',
        replay_is_open: 0,
        title: '',
        video_data: [],
        is_need_perfect_info: false,
      },
      meetingDetail: {
        title: '',
        display_time: '',
        is_subscribe: false,
      },
      socketId: '',
      player: null,
      countDTime: 0, // 倒计时
      perfectForm: { // 完善框表单
        member_id: '',
        phone: '',
        name: '',
        hospital_name: '',
        hospital_offices: '',
        job_title: '',
        password: '',
        passwordModify: '',
      },
      startTime: '', // 观看直播、回放开始时间
      endTime: '', // 观看直播、回放结束时间
      isPlayError: false, // 是否直播失败（用于状态显示进行中但直播停止推流的数据）
      isLiveTime: false, // 是否到了start_time，如果到了且live_status仍是未开始，同样可以展示推流
      isTimingSave: true, // 是否定时保存直播/回放观看时长
      sharePopupShow: false, // 分享二维码弹窗
      isHasDuration: false, // 时长面板是否展示
      durationInfo: {}, // 时长信息
      streamId: '', // 	直播会议ID
      memberId: '', // 	用户的ID
      videoId: '', // 观看目录的回放ID
      durationRemark: '', // 时长备注
      requiredViewingTime:0, //要求观看时长-分钟
      actualViewingTime:0, //实际观看时长--上报时长--秒
      viewingType:'', //观看类型
      loginPopupShow: false, // 游客提示 登录弹窗
      loginTip: '', // 游客提示登录弹窗文字
      drawNeedLogin: false, // 抽奖是否需要登录
      drawNeedRegister: false, // 抽奖是否需要完善资料
      drawNeedCountdown: false, // 抽奖是否需要倒计时
      drawStartTime: '', // 抽奖倒计时开始时间
      drawEndTime: '', // 抽奖倒计时结束时间
      raffleId: '', // 后台抽奖阶段的id
      isHasCloudHall: false, // 云展厅面板是否展示
      cloudHalls: [], // 云展厅详情
      roomInfoPanelHeight: '', // 直播标题和时间框的高度
      isHasContent: false, // 目录面板是否展示

      isBackwardReplay:false, //回放面板是否展示
      isLiveCont:false, //直播面板是否展示

      contentList: [], // 目录详情
      showQA: false, // 是否展示问卷调查
      questionInfo: {
        title: '',
        answers: []
      }, // 问卷调查详情
      myQAanswer: '', // 问卷调查答案
      isHasEnterprise: false, // 企业专区面板是否展示
      enterprises: '', // 企业专区详情
      isHasBranchMeet: false, // 分会场是否展示
      conventionDateList: [], // 多会场的日期列表
      branchMeetDefaultDate: '', // 多会场初始化时要显示到当前会议所在的日期和分会场~这里是初始日期
      branchMeetDefaultSite: '', // 多会场初始化时要显示到当前会议所在的日期和分会场~这里是初始会场
      emojiList: [
        '😀', '😄', '😅', '🤣', '😂', '😉', '😊', '😍', '😘', '😜',
        '😝', '😏', '😒', '🙄', '😔', '😴', '😷', '🤪', '🥵', '😎',
        '😮', '😰', '😭', '😱', '😩', '🥳', '🤓', '👍', '👏', '🤚',
        '👌', '🙏', '💪', '❤️', '☀️', '🌙', '⭐', '😺', '😹', '😻',
      ],
      feedbackShow: false, // 合作咨询、意见反馈、投诉弹出框
      showEmojiPanel: false, // 是否展示表情区域
      customInputHeight: 0, // 发言框高度
      customUrl: '', // 自定义链接
      customImg: '', // 自定义按钮图片
      isHasDiscuss: false, // 讨论面板是否展示

      perfectDialogIsShow:false, //默认不初始化完善资料，需要时在初始
      pcMineIsShow:false,

      convention_id:null,


    }
  },
  computed: {
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    isPc() {
      return this.$store.state.isPc
    },
    ...mapState(['userInfo']),
    isActNeedLogin() {
      // 是否需要展示登录按钮（是否是游客ID）
      return this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9'
    },
    isActNeedPerfect() {
      // 是否需要展示完善资料按钮
      return this.dataInfo.is_need_perfect_info
    },
    isShowAppoint() {
      // 是否展示预约按钮
      return !this.meetingDetail.is_subscribe && this.memberId != '' && this.memberId != '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9'
    },
    isHasBackPlay() {
      // 已结束且有回放的房间显示“回放”
      // return this.live_status == 'ENDED' && this.dataInfo.replay_is_open == 1
      // return this.dataInfo.replay_is_open == 1
      return false
    },
    isHasGuess() {
      // 目前2185号房间展示有奖竞答结果
      return this.streamId == '2185'
    },
    detailAlias() {
      // 详情别名
      if(this.dataInfo.mk_detail_name){
        let arr = this.dataInfo.mk_detail_name.split('#')
        if(arr.length > 1 && this.lanuage != 'Chinese'){
          return arr[1]
        }else{
          return arr[0]
        }
      }else {
        return this.content.detail
      }
    },
    durationAlias() {
      // 时长别名
      if(this.dataInfo.mk_duration_name){
        let arr = this.dataInfo.mk_duration_name.split('#')
        if(arr.length > 1 && this.lanuage != 'Chinese'){
          return arr[1]
        }else{
          return arr[0]
        }
      }else {
        return this.content.duration
      }
    },
    contentAlias() {
      // 目录别名
      if(this.dataInfo.mk_directory_name){
        let arr = this.dataInfo.mk_directory_name.split('#')
        if(arr.length > 1 && this.lanuage != 'Chinese'){
          return arr[1]
        }else{
          return arr[0]
        }
      }else {
        return this.content.content
      }
    },
    discussAlias() {
      // 讨论别名
      if(this.dataInfo.mk_discuss_name){
        let arr = this.dataInfo.mk_discuss_name.split('#')
        if(arr.length > 1 && this.lanuage != 'Chinese'){
          return arr[1]
        }else{
          return arr[0]
        }
      }else {
        return this.content.discuss
      }
    },
    enterpriseAlias() {
      // 企业专区别名
      if(this.dataInfo.mk_company_name){
        let arr = this.dataInfo.mk_company_name.split('#')
        if(arr.length > 1 && this.lanuage != 'Chinese'){
         return arr[1]      
        }else{
        return arr[0]
         
        }
      }else {
        return this.content.enterprise
      }
    },
    cloudHallAlias() {
      // 云展厅别名
      if(this.dataInfo.mk_gallery_name){
        let arr = this.dataInfo.mk_gallery_name.split('#')
        if(arr.length > 1 && this.lanuage != 'Chinese'){
          return arr[1]
        }else{
          return arr[0]
        }
      }else {
        return this.content.cloudHall
      }
    },
    branchMeetAlias() {
      // 多会场别名
      if(this.dataInfo.mk_conven_name){
        let arr = this.dataInfo.mk_conven_name.split('#')
        if(arr.length > 1 && this.lanuage != 'Chinese'){
          return arr[1]
        }else{
          return arr[0]
        }
      }else {
        return this.content.conven
      }
    },
    // 返回讨论，回放、时长、展厅、目录、企业专区、多会场、有奖竞答模块的组合展示数量
    chatItemNums() {
      let arr = [this.isHasDuration, this.isHasDiscuss, this.isHasCloudHall, this.isLiveCont, this.isBackwardReplay, this.isHasContent,  this.isHasEnterprise, this.isHasBranchMeet, this.isHasGuess]
      return arr.filter(v => v).length
    },
    // 内容区域总长
    chatTotalPanelWidth() {
     
      // 判断有时长、有讨论、有展厅、有目录、有企业专区、有多会场、有奖竞答的组合情况
      return `calc(${this.chatItemNums + 1}00%)`
      
      
    },
    // 内容标题栏宽度
    chatToolWidth() {
      // 详情一定展示
      return `${Number(100 / (this.chatItemNums + 1)).toFixed(6)}%`
    },
    // 内容分区宽度
    chatPanelWidth() {
      // 详情一定展示
      console.log('内容分区宽度',`${Number(100 / (this.chatItemNums +1)).toFixed(6)}%`);
      
      return `${Number(100 / (this.chatItemNums +1)).toFixed(6)}%`
    },
    // 点击动画
    chatPanelTransform() {
      // 1详情 2时长 6目录 3回放 8分会场 4讨论 5展厅 7企业专区 9有奖竞答
      let translate = ''
      let chatItemArr = ['1']
      if (this.isHasDuration) {
        chatItemArr.push('2')
      }
      if (this.isHasContent) {
        chatItemArr.push('6')
      }
      if (this.isBackwardReplay) {
        chatItemArr.push('11')
      }
      if (this.isLiveCont) {
        chatItemArr.push('10')
      }
      if (this.isHasBackPlay) {
        chatItemArr.push('3')
      }
      if (this.isHasBranchMeet) {
        chatItemArr.push('8')
      }
      if (this.isHasDiscuss) {
        chatItemArr.push('4')
      }
      if (this.isHasCloudHall) {
        chatItemArr.push('5')
      }
      if (this.isHasEnterprise) {
        chatItemArr.push('7')
      }
      if (this.isHasGuess) {
        chatItemArr.push('9')
      }
      // 当前点击的模块在数组的下标
      let index = chatItemArr.indexOf(this.activeIndex)
      translate = `translateX(-${Number((100 / chatItemArr.length) * index).toFixed(4)}%)`
      return translate
    }
  },
  watch: {
    chatValue: function(val) {
      console.log('输入框',val)
      // 由于输入框是div，可输入回车，所以要动态判断输入区域高度
      if(!this.isPc){
        this.$nextTick(()=>{
          this.customInputHeight = this.$refs.chatInputP.offsetHeight || 0
        })
      }
    },
    showEmojiPanel: function() {
      // 由于输入框是div，可输入回车，所以要动态判断输入区域高度
      if(!this.isPc){
        if(this.showEmojiPanel){
          // 如果开启表情区域，则自动聚焦
        }
        this.$nextTick(()=>{
          this.customInputHeight = this.$refs.chatInputP.offsetHeight || 0
        })
      }
    },
    activeIndex: function(val) {
      if(val == '9') {
        this.$refs.guessPanel.reloadData()
      }
    }
    // isHasBackPlay: function (val) {
    //   if (val) {
    //     this.activeIndex = '3'
    //   }
    // }
  },
  sockets: {
    //这里是监听connect事件
    connect(data) {
      // 获取每台客服端生成的id
      this.socketId = this.$socket.id;
      console.log('服务器连接', data);
    },
    reconnect(data) {
      this.$socket.emit('connect', 1)
    },
    // 监听断开连接，函数
    disconnect() {
      console.log('断开服务器连接');
      this.$socket.emit('reconnect')
    },
    // 服务端指定有msg监听的客服端，可接对应发来的收消息，data服务端传的消息
    online(data) { 
      if(this.$route.query.room!==-1){
         let obj = JSON.parse(data)
         console.log('online', obj);
         this.onlineNumber = obj.count
      }
      if(this.$route.query.room==-1){
            this.onlineNumber = 0
      }
     
    },
    chat_list(data) {
      let list = JSON.parse(data)
      let user_id = this.memberId
      let currUserId = user_id
      this.list = list.list.map(item => {
        return { ...item, isMine: item.user_id == currUserId }
      })
      console.log('taol',this.list);
    },
    add_record(data) {
      let obj = JSON.parse(data)
      // 需要完善资料
      if (obj.is_need_complete_info) {
        this.completeInfo()
      } else {
        this.chatValue = ''
        let user_id = this.memberId
        obj.isMine = obj.user_id == user_id
        this.list.push(obj)
      }
    },
    // 后台设置倒计时，给前端首页进行提醒
    countdown_warn(data) {
      // console.log('countdown_warn', data);
      this.changeDrawButton(data, 'countdown_warn')
    },
    // 定时给首页发送抽奖的最新数据
    raffle_home(data) {
      // console.log('raffle_home', data);
      this.changeDrawButton(data, 'raffle_home')
    },
    // 定时会给首页发送问答的问题
    question_info(data) {
      // console.log('question_info', data);
      this.questionInfo = JSON.parse(data)
      // this.showQA = true
      // 改为有奖竞猜形式
      if(this.streamId == '2185') {
        if(this.isPc){
          this.$refs.pcGuess.showDialog(this.questionInfo)
        }else{
          this.$refs.mobileGuess.showDialog(this.questionInfo)
        }
      }
    },
    connect_result(data) { },
    error(err) {
      console.log('error', err);
    }
  },
  beforeRouteEnter(to, from, next) {
    // 只能由auth跳转进入
    if (from.path != '/auth' && from.path != '/feedback' && from.path != '/complain' && from.path != '/mine') {
      if(to.query.memberId) {
        // 如果传多个memberId，从后往前取，如果为空则跳过继续查找直到不为空为止
        if(to.query.memberId instanceof Array){
          let memberIds = to.query.memberId
          for(let i = memberIds.length - 1;i >= 0;i--) {
            if(memberIds[i] != ''){
              localStorage.setItem('loginItem', JSON.stringify({ userId: memberIds[i] }))
              break
            }
          }
        }else{
          localStorage.setItem('loginItem', JSON.stringify({ userId: to.query.memberId }))
        }
      }
      next({
        path: '/entry',
        query: {
          // memberId: to.query.memberId,
          openId: to.query.openId,
          conventionId: to.query.conventionId,
          room: to.query.room,
          live_meeting_id: to.query.live_meeting_id,
          siteId: to.query.siteId,
          video_id: to.query.video_id,
        },
        replace: true
      })
      return // 避免鉴权前多次发起socket的情况
    }
    let memberId = to.query.memberId
    let user_id = ''
    if (memberId) {
      // 若地址有传则用地址的
      user_id = memberId
    } else {
      // 若地址不传则先取缓存的，没缓存则默认游客
      if (localStorage.getItem('loginItem')) {
        user_id = JSON.parse(localStorage.getItem('loginItem')).userId
      } else {
        user_id = '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9'
      }
    }
    let params = {
      room: to.query.room ? to.query.room : -1, // 如果路由包含room则取路由的room，否则默认-1
      user_id: user_id,
      live_metting_id: to.query.live_meeting_id,
    }
    Vue.use(new VueSocketIO({
      debug: false,
      connection: config.socket,
      options: { query: params, transports: ['websocket'] }
    }));
    next();
  },
  created() {
    // 开启“关闭浏览器”监听
    window.addEventListener('pagehide', this.updateHandler)
    window.addEventListener('visibilitychange', this.visibleChangeHandler);
    let memberId = this.$route.query.memberId
    if (memberId) {
      // 若地址有传则用地址的
      this.memberId = memberId
    } else {
      // 若地址不传则先取缓存的，没缓存则默认游客
      if (localStorage.getItem('loginItem')) {
        this.memberId = JSON.parse(localStorage.getItem('loginItem')).userId
      } else {
        this.memberId = '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9'
      }
    }
    this.videoId = this.$route.query.video_id // 记录正观看的回放ID
    this.streamId = this.$route.query.room
    this.initContentDetail() //初始话目录列表
  },
  mounted() {
    if(Number(this.streamId) != -1) {
      this.timeoutUpdate()
      // http://192.168.1.6:8080/#/chat-online?user_id=72C7F45E-93BE-41CD-88F7-CB31E498D95A&room=21
       this.initLiveMeeting()
      setInterval(() => {
        this.$socket ? this.$socket.emit('listen_connect', this.socketId) : null
       
        
      }, 30000)
      // 自动生成二维码
      QRCode.toCanvas(document.getElementById('qrcode'), `${window.location.href.indexOf('memberId') > -1 ?  window.location.href : `${window.location.href}&memberId=${this.memberId}`}`, { width:200 },(err)=>{
        // console.log('qrcodeerr',err);
      })
    }
  },
  beforeDestroy() {
    // 关闭网页前或跳转其他直播间前，销毁播放器，否则tcplayer内部会缓存当前播放器id，造成播放器不展示
    this.player ? this.player.dispose() : null
    this.$socket.close()
    // 移除“关闭浏览器”监听
    window.removeEventListener('pagehide', this.updateHandler)
    window.removeEventListener('visibilitychange', this.visibleChangeHandler);
  },
  methods: {
    // 每隔3分钟上报一次观看直播/回放的时长记录
    timeoutUpdate() {
      const _this = this
      if (_this.startTime != '') {
        if (_this.live_status == 'ENDED' || this.historyUrl !== '') {
          // 已结束状态
          _this.endTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
          _this.addWatchRecord('VOD',this.convention_id)
           console.log(_this.startTime);
            console.log(_this.endTime);
        } else if (_this.live_status == 'IN_HAND') {
          // 直播中状态
          _this.endTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
          _this.addWatchRecord('LIVE',this.convention_id)
        }
        // 每10分钟上报后，开始时间从上报时间开始重新记录
        _this.startTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
      }
      setTimeout(() => {
        _this.timeoutUpdate()
      }, 180000 ) //3分钟上报一次
    },
    // 在安卓或ios的webview中，置于后台时需要暂停播放
    visibleChangeHandler(e){
      // console.log(e, 'visibleChangeHandler');
      if (e.target.visibilityState === "visible") {
        //进入
        this.player ? this.player.play() : null
      } else if (e.target.visibilityState === "hidden") {
        //离开
        this.player ? this.player.pause() : null
      }
    },
    updateHandler(e) {
      this.player ? this.player.dispose() : null // 采用webrtc拉流后，在app中可能会再播放一段时间，因此需要销毁
      if (this.live_status == 'ENDED' || this.historyUrl !== '') {
        // 已结束状态
        if (this.startTime != '') {
          this.endTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
          this.addWatchRecord('VOD')
        }
      } else if (this.live_status == 'IN_HAND') {
        // 直播中状态
        if (this.startTime != '') {
          this.endTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
          this.addWatchRecord('LIVE')
        }
      }
      this.startTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
    },
    // 初始化
    initLiveMeeting() {
      const _this = this
      postLiveMeetDetail({
         live_meet_id: Number(this.streamId),
         member_id: this.memberId
      }).then(res => {
        console.log('initLiveMeeting',res);
        
        this.convention_id = res.data.convention_id; //将获取到的id传参给自动上报时长
        // res.data.live_status = 'NOT_STARTED'
        // res.data.live_start_time = '2023-03-12 22:23:00'
        // this.streamId = res.data.id
        this.live_status = res.data.live_status
        // 后台live_status记录的是推流的状态，而不是实际直播开始时间，所以只能根据live_start_time判断，如果当前时间小于直播时间，则按未开始计
        if((res.data.live_start_time || '') != '' && new Date() < new Date(res.data.live_start_time.replace(/-/g, '\/'))) {
          this.live_status = 'NOT_STARTED'
        }
        // start_time是开始推流时间，live_start_time是开始直播时间，如果当前时间大于start_time，且未开始状态，则标记为可展示推流状态
        if((res.data.start_time || '') != '' && new Date() >= new Date(res.data.start_time.replace(/-/g, '\/')) && this.live_status == 'NOT_STARTED') {
          this.isLiveTime = true
        } else {
          this.isLiveTime = false
        }
        this.dataInfo = res.data
        this.onlineTitle = res.data.title
        // 如果开启讨论，则展示讨论信息
        if (res.data.discuss_is_open == 1) {
          this.isHasDiscuss = true
          this.$nextTick(()=>{
            _this.customInputHeight = _this.$refs.chatInputP && _this.$refs.chatInputP.offsetHeight || 0
          })
        } else {
          this.isHasDiscuss = false
        }
        // 如果时长信息存在，则展示时长信息
        if (res.data.duration_is_open == 1) {
          this.durationInfo = res.data.duration_info
          this.isHasDuration = true;
          this.getConventionDuration(Number(this.$route.query.conventionId));
          this.durationRemark = res.data.duration_remark
        } else {
          this.isHasDuration = false
          this.durationRemark = ''
        }
        // 如果开启云展厅，则展示云展厅信息
        if (res.data.is_have_cloud_hall) {
        
          this.cloudHalls = res.data.cloud_halls
          this.isHasCloudHall = true
        } else {
          this.cloudHalls = []
          this.isHasCloudHall = false
        }
        // 如果开启企业专区，则展示企业专区信息
        if (res.data.is_enterprise) {
          console.log('666',res.data.is_enterprise);        
          this.enterprises = res.data.enterprise_image
          this.isHasEnterprise = true
        } else {
          this.enterprises = ''
          this.isHasEnterprise = false
        }
        // 如果开启多会场，则展示多会场信息 多会场信息列表？
        if (res.data.is_conven && _this.$route.query.conventionId) {
          this.branchMeetDefaultDate = res.data.live_start_time.substring(0, 10) // 截取时间
          this.branchMeetDefaultSite = this.$route.query.siteId || '' // 初始会场
          this.isHasBranchMeet = true
          this.isHasContent =false// 如果开启多会场信息，则需要隐藏目录模块
          this.getConventionDate(Number(_this.$route.query.conventionId))
        } else {
          this.branchMeetDefaultDate = ''
          this.branchMeetDefaultSite = ''
          this.conventionDateList = []
          this.isHasBranchMeet = false
        }
        if (this.dataInfo.replay_is_open == 0) {
          // 未开启回放的状态下 展示推流
          this.$nextTick(() => {
            this.initTCPlayer(res.data.pull_udp_ip, res.data.cover_url)
          })
        }
        if (this.live_status == 'NOT_STARTED' && this.dataInfo.live_start_time != '') {
          // 未开始
          this.countDTime = new Date(this.dataInfo.live_start_time.replace(/-/g, '\/')).getTime() - new Date()
          this.countDownTime(this.dataInfo)
        }
        // 抽奖
        if (res.data.raffle_is_open == 1) {
          // 需要登录/完善资料
          if (res.data.raffle_type == 'Perfect Info') {
            this.drawNeedCountdown = false
            this.drawStartTime = ''
            this.drawEndTime = ''
            this.raffleId = ''
            if (res.data.raffle_is_need_login) {
              // 需要登录
              this.drawNeedLogin = true
              this.drawNeedRegister = false
            } else {
              // 需要完善资料
              this.drawNeedLogin = false
              this.drawNeedRegister = true
            }
          } else {
            this.drawNeedLogin = false
            this.drawNeedRegister = false

            this.drawStartTime = res.data.raffle_info.start_time || ''
            this.drawEndTime = res.data.raffle_info.end_time || ''
            this.raffleId = res.data.raffle_info.id || ''
            if (res.data.raffle_is_countdown == 1) {
              // 显示倒计时
              this.drawNeedCountdown = true
            } else {
              // 不显示倒计时
              this.drawNeedCountdown = false
            }
          }
          this.$refs.drawBtn.show({
            needLogin: this.drawNeedLogin,
            needPerfect: this.drawNeedRegister,
            needCountdown: this.drawNeedCountdown,
            startTime: this.drawStartTime,
            endTime: this.drawEndTime
          })
        } else {
          this.$refs.drawBtn.close()
        }
        // 显示调查问卷
        if(JSON.stringify(res.data.question) !== '{}'){
          this.questionInfo = {...res.data.question}
          // this.showQA = true
          // 改为有奖竞猜形式
          if(this.streamId == '2185') {
            if(this.isPc){
              this.$refs.pcGuess.showDialog(this.questionInfo)
            }else{
              this.$refs.mobileGuess.showDialog(this.questionInfo)
            }
          }
        }else {
          // this.showQA = false
          // 改为有奖竞猜形式
          if(this.streamId == '2185') {
            if(this.isPc){
              this.$refs.pcGuess.closeDialog()
            }else{
              this.$refs.mobileGuess.closeDialog()
            }
          }
        }
        // 如果是点击的视频跳进来的直播间，则要回显回放的视频
        if(this.$route.query.video_id) {
          let videoList = res.data.video_data.filter(v=>v.id==Number(this.$route.query.video_id))
          if(videoList.length > 0) {
            this.showHistory(videoList[0], -1)
          }
        }
        // 如果开启，则显示自定义按钮
        if(res.data.fun_xf && res.data.fun_xf.isopen == 1){
          this.customImg = res.data.fun_xf.icon || ''
          this.customUrl = res.data.fun_xf.url || ''
        }
        if (sessionStorage.getItem('leaveFromCloud') && sessionStorage.getItem('leaveFromCloud').toString() == this.streamId.toString() && this.isHasCloudHall) {
          // 从云展厅离开又后退回来的，展示云展厅模块
          this.activeIndex = '5'
          sessionStorage.removeItem('leaveFromCloud')
        } else if (sessionStorage.getItem('leaveFromDiscuss') && sessionStorage.getItem('leaveFromDiscuss').toString() == this.streamId.toString() && this.isHasDiscuss) {
          // 前往意见反馈，投诉和个人资料又后退回来的，展示讨论模块
          this.activeIndex = '4'
          sessionStorage.removeItem('leaveFromDiscuss')
        } else if (this.isHasBranchMeet) {
          // 有多会场的优先展示多会场
          this.activeIndex = '8'
        } else if (this.isHasBackPlay) {
          // 有回放的优先展示回放
          this.activeIndex = '3'
        } else if (this.isHasContent) {
          // 有目录的优先展示目录
          this.activeIndex = '6'
         } 
         else if (this.isHasCloudHall) {
          // 有云展厅的优先展示展厅
          this.activeIndex = '5'
        }
        this.initWxBtns()
      })
    },
    // 初始化目录列表
    initContentDetail() {    
      postMettingDetail({
        live_metting_id: this.$route.query.live_meeting_id ? Number(this.$route.query.live_meeting_id) : null,
        member_id: this.memberId,
      }).then(res => {
        this.meetingDetail = res.data       
        if(this.meetingDetail.stream_list.length > 1 && !this.isHasBranchMeet){
          // this.isHasContent = true;
          // //当有目录面板的时候，优先展示目录面板
          // this.activeIndex = '6';
          if(this.$route.query.live_meeting_id === '2226'){
            this.isLiveCont = true;
            this.isBackwardReplay = true;
            if(this.$route.query.video_id){
              this.activeIndex = '11';
            }else {
              this.activeIndex = '10';
            }

          }else {
            this.isHasContent = true;
            //当有目录面板的时候，优先展示目录面板
            this.activeIndex = '6';
          }
        }
        else if(this.meetingDetail.stream_list.length == 1 && !this.isHasBranchMeet){
          // 只有单个直播间或单个视频时不展示目录
          this.isHasContent = false
        }else {
          this.$toast(this.content.noLiveTip)
          this.isHasContent = false
        }
        // 待页面更新后，动态读取直播标题、时间区域的高度，用于高度计算处理
        if(!this.isPc){
          this.$nextTick(() => {
            this.roomInfoPanelHeight = this.$refs.roomInfoPanel.offsetHeight || 0
          })
        }
      })
    },
    // 当前直播间内切换视频
    watchVideo(item){  
      this.showHistory(item, -1)
    },
    // 切换直播、回放
    contentExchangeLive(item) {
    
      
      if (item.type == 'live') {
        this.$router.push({
          path: '/auth',
          query: {
            // memberId: this.memberId,
            openId: this.$route.query.openId,
            conventionId: this.$route.query.conventionId,
            room: item.stream_id,
            live_meeting_id: this.$route.query.live_meeting_id
          }
        })

        if(this.$route.query.live_meeting_id == '2226'){
          this.activeIndex = '11';
        }
      } else {
        // 模拟点击回放
        this.$router.push({
          path: '/auth',
          query: {
            // memberId: this.memberId,
            openId: this.$route.query.openId,
            conventionId: this.$route.query.conventionId,
            room: item.stream_id,
            live_meeting_id: this.$route.query.live_meeting_id,
            video_id: item.id,
          }
        })

        if(this.$route.query.live_meeting_id == '2226'){
          this.activeIndex = '10';
        }
      }
    },
    // 初始化socket
    useSocketIO() {
      this.$socket.connected? this.$socket.close(): null
      this.$socket.io.opts.query = {
        room: this.streamId,
        user_id: this.memberId
      }
      this.$socket.open()
    },
    // 上报成功回调
    reportSuccess() {
      postLiveMeetDetail({
        live_meet_id: Number(this.streamId),
        member_id: this.memberId
      }).then(res => {
        this.live_status = res.data.live_status
        // 后台live_status记录的是推流的状态，而不是实际直播开始时间，所以只能根据live_start_time判断，如果当前时间小于直播时间，则按未开始计
        if((res.data.live_start_time || '') != '' && new Date() < new Date(res.data.live_start_time.replace(/-/g, '\/'))) {
          this.live_status = 'NOT_STARTED'
        }
        this.dataInfo = res.data
        // 如果时长信息存在，则展示时长信息
        if (res.data.duration_is_open == 1) {
          this.durationInfo = res.data.duration_info
          this.isHasDuration = true;
          this.getConventionDuration(Number(this.$route.query.conventionId));
          this.durationRemark = res.data.duration_remark;
        } else {
          this.isHasDuration = false
          this.durationRemark = ''
        }
      })
    },
    // 初始化腾讯云直播控件
    initTCPlayer(url, poster) {
      const _this = this
      this.player ? this.player.dispose() : null
      // this.player ? this.player.destroy() : null
      try{
        // this.player = new TcPlayer('player-container-id', {
        //   "m3u8": url, //请替换成实际可用的播放地址
        //   "autoplay": true,      //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        //   // "poster": { src: poster, style: 'stretch' },
        //   "live": true,
        //   "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
        //   "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
        //   listener: function (msg) {
        //     if (msg.type == 'playing') {
        //       // 因缓冲而暂停或停止后恢复播放时触发，paused 属性为 false 。通常用这个事件来标记视频真正播放，play 事件只是开始播放，画面并没有开始渲染
        //       _this.startTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
        //       _this.$refs.durationPanel ? _this.$refs.durationPanel.beginCount() : null
        //     } else if (msg.type == 'pause') {
        //       // 暂停时触发
        //       if (_this.startTime != '') {
        //         _this.endTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
        //         _this.addWatchRecord('LIVE')
        //       }
        //       _this.startTime = ''
        //       _this.$refs.durationPanel ? _this.$refs.durationPanel.pauseCount() : null
        //     } else if (msg.type == 'error') {
        //       // 视频播放出现错误时触发
        //       if (_this.startTime != '') {
        //         _this.endTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
        //         _this.addWatchRecord('LIVE')
        //       }
        //       _this.startTime = ''
        //       _this.isPlayError = true // 直播推流失败了
        //       _this.$refs.durationPanel ? _this.$refs.durationPanel.pauseCount() : null
        //     }
        //   }
        // });
        this.$nextTick(() => {
        this.player = TCPlayer(`player-container-id${this.streamId}`, {
          sources: [`${url}&tabr_control=auto`],
          // licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1252497858_1/v_cube.license',
          controlBar: {
            currentTimeDisplay: false,
            durationDisplay: false,
            timeDivider: false,
            QualitySwitcherMenuButton: false,
            playbackRateMenuButton: false
          },
          autoplay: true,      //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
          // "poster": { src: poster, style: 'stretch' },
          width: '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
          height: '100%', //视频的显示高度，请尽量使用视频分辨率高度
        });
        this.player.on('playing', function(){
          // 因缓冲而暂停或停止后恢复播放时触发，paused 属性为 false 。通常用这个事件来标记视频真正播放，play 事件只是开始播放，画面并没有开始渲染
          _this.startTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
          _this.$refs.durationPanel ? _this.$refs.durationPanel.beginCount() : null
        })
        this.player.on('pause', function(){
          // 暂停时触发
          if (_this.startTime != '') {
            _this.endTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
            _this.addWatchRecord('LIVE')
          }
          _this.startTime = ''
          _this.$refs.durationPanel ? _this.$refs.durationPanel.pauseCount() : null
        })
        this.player.on('error', function(e){
          console.log(e);
          _this.isPlayError = true // 直播推流失败了
          // console.log('直播推流失败了-----------',_this.isPlayError)
          // 视频播放出现错误时触发
          if (_this.startTime != '') {
            _this.endTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
            _this.addWatchRecord('LIVE')
          }
          _this.startTime = ''
          _this.$refs.durationPanel ? _this.$refs.durationPanel.pauseCount() : null
        })
      })
      }catch(e) {
        this.isPlayError = true
        console.log('直播推流-----------',this.isPlayError)
        console.log(e, 'TCPlayer error');
      }
    },
    // 发送消息
    search() {
      // 有实际内容且房间号不为-1
      if (this.chatValue.trim() && Number(this.streamId) != -1) {
        let user_id = this.memberId
        if (user_id == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9') {
          // this.$toast('游客模式下不能发言，谢谢')
          this.loginTip = this.content.discussLoginTip;
          this.loginPopupShow = true;
        } else {
          console.log('发表言论')
          console.log('555',this.$socket,this.chatValue);
          
          this.$socket.emit('add_message', JSON.stringify({ message: this.chatValue }))
        }
      }
    },
    // 面板切换
    change(type) {
      if(!this.isPc){
        this.showEmojiPanel = false
      }
      this.activeIndex = type;
    },
    // 观看历史回放
    showHistory(item, index) {
      const _this = this
      this.historyUrl = item.video_url
      this.historyActiveIndex = index
      this.$nextTick(() => {
        _this.$refs.historyRef.addEventListener('play', function () {//播放开始执行的函数
          _this.startTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
          _this.$refs.durationPanel ? _this.$refs.durationPanel.beginCount() : null
        });
        _this.$refs.historyRef.addEventListener('pause', function () {//暂停开始执行的函数
          _this.endTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
          _this.addWatchRecord('VOD')
          _this.startTime = ''
          _this.$refs.durationPanel ? _this.$refs.durationPanel.pauseCount() : null
        });
      })
    },
    // 未开始直播倒计时
    countDownTime(item) {
      let willLiveStart = new Date(item.live_start_time.replace(/-/g, '\/')).getTime() - new Date()
      let willStart = 0
      if (item.start_time != '') {
        // 避免start_time为空
        willStart = new Date(item.start_time.replace(/-/g, '\/')).getTime() - new Date()
      }
      // 避免因人为因素，设置start_time大于live_start_time，不符合当前规则导致出现bug
      if (new Date(item.start_time.replace(/-/g, '\/')).getTime() < new Date(item.live_start_time.replace(/-/g, '\/')).getTime()) {
        // 这里取直播开始时间live_start_time和开始推流时间start_time，对比是否达到对应时间，如果有一个达到则默认开始直播，这里start_time一般早于live_start_time
        if (willLiveStart >= 0) {
          if (willStart >= -1200 && willStart < 0 && !this.isLiveTime) {
            // 在计时到达start_time的1.8s（担心性能影响不能在1s内执行）内，重新查一遍详情，初始化推流
            this.initLiveMeeting()
          }else{
            setTimeout(() => {
              this.countDownTime(item)
            }, 1000)
          }
        } else {
          this.initLiveMeeting()
        }
      }
    },
    // 记录观看直播时间或观看回放时间
    addWatchRecord(type,convention_id) {
      // const _this = this
      // let user_id = this.memberId
      // postAddWatchRecord({
      //   stream_id: Number(_this.streamId),
      //   user_id: user_id,
      //   type: type,
      //   start_time: this.startTime,
      //   end_time: this.endTime,
      //   convention_id: _this.$route.query.conventionId ? Number(_this.$route.query.conventionId) : null
      // }).then(res => {
      //   // console.log(res.data);
      // })

    //  startTime和endTime相同，则不上报时长,直播推流失败，不上报

      let startTime = new Date(this.startTime);
      let endTime = new Date(this.endTime);
      console.log(startTime.getTime() , endTime.getTime() , !this.isPlayError)
      // console.log(startTime,'--------------',endTime)
      if((startTime.getTime() !== endTime.getTime()) && !this.isPlayError){
        const _this = this
        let user_id = this.memberId
        let data={
          stream_id: Number(_this.streamId),
          user_id: user_id,
          type: type,
          duration_type:this.viewingType ? this.viewingType : type,
          start_time: this.startTime,
          end_time: this.endTime,
          convention_id: _this.$route.query.conventionId ? Number(_this.$route.query.conventionId) : null
        }
        let headers={ 'x-client-tag':'live_h5'}
      
        
        axios.post('https://live-api.yunicu.com/live/live-meet/add_watch_record',data,{ headers })
            .then(res => { 
            
              
                // this.actualViewingTime = res.data.data.totalDuration;
            })

        // postAddWatchRecord({
        //   stream_id: Number(_this.streamId),
        //   user_id: user_id,
        //   type: type,
        //   duration_type:this.viewingType ? this.viewingType : type,
        //   start_time: this.startTime,
        //   end_time: this.endTime,
        //   convention_id: convention_id //自动上报中传参convention_id，在detail中获取到的convention_id
        // }).then(res => {
        //   // console.log('上报时长返回数据',res.data);
        // //  获取上报观看时长（实际观看时长）
        //   this.actualViewingTime = res.data.data.totalDuration;
        // })
      }else {
        // console.log('时间相同/直播推流不失败，不上报')
      }

    },
    // 左侧返回按钮
    leftBtn() {
      history.back()
      // window.location.href = `${config.leftBackUrl}?convention_id=${this.$route.query.conventionId ? Number(this.$route.query.conventionId) : null}`
    },
    // 右侧主页按钮
    rightBtn() {
      window.location.href = `${config.rightBackUrl}?convention_id=${this.$route.query.conventionId ? Number(this.$route.query.conventionId) : null}`
    },
    // 初始化用户信息
    async completeInfo() {
      // 未注册过需要完善资料
      const res1 = await postUserInfo({
        member_id: this.memberId
      })
      if (res1.data.code == 0) {
        this.perfectDialogIsShow = true;//初始化完善资料页面
        this.$nextTick(()=>{
          this.perfectForm = { // 完善框表单
            member_id: this.memberId,
            phone: res1.data.data.tel || '',
            name: res1.data.data.name || '',
            hospital_name: res1.data.data.hospital_name || '',
            hospital_offices: res1.data.data.hospital_offices || '',
            job_title: res1.data.data.job_title || '',
            password: '',
            passwordModify: '',
          }
          console.log('完善资料赋值数据',this.perfectForm)
          this.$refs.perfectDialog.showDialog();//打开完善资料弹窗
        })
      }

      // this.$refs.perfectDialog.showDialog();//打开完善资料弹窗
    },
    // 完善资料
    perfectSuccess() {
      let params = {
        room: this.$route.query.room,
        user_id: this.memberId
      }
      Vue.use(new VueSocketIO({
        debug: false,
        connection: config.socket,
        options: { query: params, transports: ['websocket'] }
      }));
      this.peaceReload()
    },
    // 登录按钮
    loginPopup() {
      this.loginPopupShow = false
      if(this.lanuage == 'Chinese') {
        // 中文状态下手机号登录
        this.$refs.loginDialog.showDialog()
      }else {
        // 英文状态下邮箱登录
        this.$refs.emailLoginDialog.showDialog()
      }
    },
    // 重新登录需要完善资料
    needRegister(obj) {
      this.memberId = obj.id
      // 重新登录后将最新memberId缓存 防止刷新刷没了
      localStorage.setItem('loginItem', JSON.stringify({ userId: obj.id }))
      this.completeInfo()
    },
    // 重新登录成功
    loginSuccess(obj) {
      this.memberId = obj.id
      // 重新登录后将最新memberId缓存 防止刷新刷没了
      localStorage.setItem('loginItem', JSON.stringify({ userId: obj.id }))
      let params = {
        room: this.$route.query.room,
        user_id: this.memberId
      }
      // Vue.use(new VueSocketIO({
      //   debug: false,
      //   connection: config.socket,
      //   options: { query: params, transports: ['websocket'] }
      // }));
      this.peaceReload()
    },
    // 重新登录失败
    loginFail() {
      this.$refs.loginDialog.closeDialog()
    },
    // 重新邮箱登录失败
    emailLoginFail() {
      this.$refs.emailLoginDialog.closeDialog()
    },
    // 游客模式
    visitorLogin() {
      this.$refs.loginDialog.closeDialog()
      this.$refs.emailLoginDialog.closeDialog()
    },
    // 静默刷新
    peaceReload() {
      postLiveMeetDetail({
        live_meet_id: Number(this.streamId),
        member_id: this.memberId
      }).then(res => {
        // this.streamId = res.data.id
        this.live_status = res.data.live_status
        // 后台live_status记录的是推流的状态，而不是实际直播开始时间，所以只能根据live_start_time判断，如果当前时间小于直播时间，则按未开始计
        if((res.data.live_start_time || '') != '' && new Date() < new Date(res.data.live_start_time.replace(/-/g, '\/'))) {
          this.live_status = 'NOT_STARTED'
        }
        this.dataInfo = res.data
        this.onlineTitle = res.data.title
        // 如果时长信息存在，则展示时长信息
        if (res.data.duration_is_open == 1) {
          this.durationInfo = res.data.duration_info
          this.isHasDuration = true
          this.getConventionDuration(Number(this.$route.query.conventionId));
          this.durationRemark = res.data.duration_remark;
        } else {
          this.isHasDuration = false
          this.durationRemark = ''
        }
        // 如果开启多会场，则展示多会场信息
        if (res.data.is_conven && this.$route.query.conventionId) {
          this.isHasBranchMeet = true
          this.getConventionDate(Number(this.$route.query.conventionId))
        } else {
          this.conventionDateList = []
          this.isHasBranchMeet = false
        }
        // 抽奖
        if (res.data.raffle_is_open == 1) {
          if (res.data.raffle_type == 'Perfect Info') {
            this.drawNeedCountdown = false
            this.drawStartTime = ''
            this.drawEndTime = ''
            this.raffleId = ''
            if (res.data.raffle_is_need_login) {
              // 需要登录
              this.drawNeedLogin = true
              this.drawNeedRegister = false
            } else {
              // 需要完善资料
              this.drawNeedLogin = false
              this.drawNeedRegister = true
            }
          } else {
            this.drawNeedLogin = false
            this.drawNeedRegister = false
            this.drawStartTime = res.data.raffle_info.start_time || ''
            this.drawEndTime = res.data.raffle_info.end_time || ''
            this.raffleId = res.data.raffle_info.id || ''
            if (res.data.raffle_is_countdown == 1) {
              // 显示倒计时
              this.drawNeedCountdown = true
            } else {
              // 不显示倒计时
              this.drawNeedCountdown = false
            }
          }
          this.$refs.drawBtn.show({
            needLogin: this.drawNeedLogin,
            needPerfect: this.drawNeedRegister,
            needCountdown: this.drawNeedCountdown,
            startTime: this.drawStartTime,
            endTime: this.drawEndTime
          })
        } else {
          this.$refs.drawBtn.close()
        }
      })
    },
    // 抽奖需要登录
    drawLogin() {
      this.loginTip = this.content.drawLoginTip
      this.loginPopupShow = true
    },
    // 抽奖需要完善资料
    drawRegister() {
      this.completeInfo()
    },
    // 展示抽奖面板
    showDrawPanel(time) {
      setTimeout(() => {
        this.$refs.lotteryDraw.show({
          streamId: this.streamId,
          memberId: this.memberId
        })
      }, time)
      // 开始抽奖则退出全屏
      this.player ? this.player.exitFullscreen() : null
      // this.player ? this.player.fullscreen(false) : null
    },
    // 抽奖成功
    drawSuccess(data) {
      this.$refs.lotteryDraw.close()
      this.$refs.drawSuccessDialog.show({
        winning_id: data.id,
        name: data.name,
        tel: data.tel,
        email: data.email,
        receiving_address: data.receiving_address,
        type: data.type,
        prize: data.prize
      })
    },
    // 抽奖失败
    drawFail() {
      this.$refs.lotteryDraw.close()
      this.$refs.drawFailDialog.show()
    },
    // 根据socket判断是否修改抽奖按钮
    changeDrawButton(res, type) {
      let data = JSON.parse(res)
      if (type == 'countdown_warn') {
        if (data.raffle_is_open == 1) {
          // this.drawNeedLogin = false
          // this.drawNeedRegister = false
          this.drawStartTime = data.start_time
          this.drawEndTime = data.end_time
          this.raffleId = data.id
          if (data.raffle_is_countdown == 1) {
            // 显示倒计时
            this.drawNeedCountdown = true
          } else {
            // 不显示倒计时
            this.drawNeedCountdown = false
          }
          this.$forceUpdate()
          this.$refs.drawBtn.show({
            needLogin: this.drawNeedLogin,
            needPerfect: this.drawNeedRegister,
            needCountdown: this.drawNeedCountdown,
            startTime: this.drawStartTime,
            endTime: this.drawEndTime
          })
        }
      } else if (type == 'raffle_home') {
        if (String(this.raffleId) != String(data.id)) {
          // this.drawNeedLogin = false
          // this.drawNeedRegister = false
          this.raffleId = data.id
          this.drawStartTime = data.start_time
          this.drawEndTime = data.end_time
          if (data.raffle_is_countdown == 1) {
            // 显示倒计时
            this.drawNeedCountdown = true
          } else {
            // 不显示倒计时
            this.drawNeedCountdown = false
          }
          this.$refs.drawBtn.show({
            needLogin: this.drawNeedLogin,
            needPerfect: this.drawNeedRegister,
            needCountdown: this.drawNeedCountdown,
            startTime: this.drawStartTime,
            endTime: this.drawEndTime
          })
        }
      }
    },
    // 展厅点击跳转
    goCloudHall(item) {
      if (item.target_url) {
        sessionStorage.setItem('leaveFromCloud', this.streamId)
        window.location.href = item.target_url
      }
    },
    // 查看隐私协议，仅查看
    lookPolicy() {
      this.$refs.policyDialog.showDialogWithoutCheck()
    },
    // 自定义按钮
    customBtnClick() {
      window.location.href = this.customUrl
    },
    // 登录或完善资料
    logOrPerfect() {
      if(this.isActNeedLogin){
        // 主动触发弹出登录
        this.loginPopup()
      }else if(this.isActNeedPerfect){
        // 主动触发弹出完善资料
        this.completeInfo()
      }
    },
    // 预约
    makeAppoint() {
      postAddSubscribeRecord({
        member_id: this.memberId,
        openid: this.$route.query.openId,
        metting_id: Number(this.$route.query.live_meeting_id)
      }).then(res => {
        if (res.data.code == 0) {
          this.meetingDetail.is_subscribe = true
          this.$toast(res.data.data.message)
        } else {
          this.$toast((this.content.appointFail + ':') + res.data.message)
        }
      })
    },
    // 回答调查问卷
    answerMyQuestion(name) {
      postAddQuestionAnswer({
        live_metting_id: this.$route.query.live_meeting_id ? Number(this.$route.query.live_meeting_id) : null,
        live_stream_id: Number(this.streamId),
        member_id: this.memberId,
        question: this.questionInfo.title,
        answer: name,
        question_id: this.questionInfo.id
      }).then(res => {
        if (res.data.code == 0) {
          this.showQA = false
        } else {
          this.showQA = false
        }
      })
    },
    // 意见反馈
    feedback() {
      if (this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9') {
        // this.$toast('游客模式下不能意见反馈，谢谢')
        this.feedbackShow = false
        this.loginTip = this.content.feedbackLoginTip
        this.loginPopupShow = true
      } else {
        sessionStorage.setItem('leaveFromDiscuss', this.streamId)
        this.$router.push({
          path: '/feedback'
        })
      }
    },
    // 投诉
    complain() {
      if (this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9') {
        // this.$toast('游客模式下不能投诉，谢谢')
        this.feedbackShow = false
        this.loginTip = this.content.complainLoginTip
        this.loginPopupShow = true
      } else {
        sessionStorage.setItem('leaveFromDiscuss', this.streamId)
        this.$router.push({
          path: '/complain'
        })
      }
    },
    // 我的资料
    mine(){
      if (this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9') {
        // this.$toast('游客模式下不能意见反馈，谢谢')
        this.feedbackShow = false
        this.loginTip = this.content.mineLoginTip
        this.loginPopupShow = true
      } else {
        sessionStorage.setItem('leaveFromDiscuss', this.streamId)
        this.$router.push({
          path: '/mine',
          query: {
            openId: this.$route.query.openId,
            conventionId: this.$route.query.conventionId,
            room: this.$route.query.room,
            live_meeting_id: this.$route.query.live_meeting_id,
            siteId: this.$route.query.siteId,
            video_id: this.$route.query.video_id,
          }
        })
      }
    },
    // 增加表情
    addEmoji(html) {
      this.$refs.customInput.setDataList(html, 1)
    },
    // 获取多会场的日期
    getConventionDate(id) {
      getConventionDetail({
        id,
        type: 'DHZB'
      }).then(res => {
        if (res.data.code == 0) {
          this.conventionDateList = res.data.data.date_list
          console.log('多会场',this.conventionDateList);
          
        } else {
          this.conventionDateList = []
        }
      })
    },
    // 获取多会场的要求观看时长和实际观看时长
    getConventionDuration(id) {
      getConventionDetail({
        id,
        type: 'DHZB'
      }).then(res => {
        if (res.data.code == 0) {
          this.requiredViewingTime = res.data.data.duration ? res.data.data.duration : 0; //要求观看时长
          this.viewingType = res.data.data.duration_type ? res.data.data.duration_type :''; //要求观看类型
          //  初始加载一次上报时长，获取实际观看时间
          this.startTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
          setTimeout(()=>{
            this.endTime = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
            this.addWatchRecord('LIVE',this.convention_id)
          },1000) //防止开始时间和结束时间一致，导致不上报时长
        }
      })
    },
    // 点击头像弹窗
    avatarClick() {
      if(this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9') {
        // 游客模式下发起登录
        this.loginPopup()
      } else {
        // 登录状态下弹出选择框
        this.$refs.logoutDialog.showDialog()
      }
    },
    // pc端查看我的资料
    pcMineInfo() {
      this.pcMineIsShow = true;
      this.$nextTick(()=>{
        this.$refs.pcMine.showDialog()
      })
    },
    // pc端意见反馈
    pcFeedback() {
      this.$refs.pcFeedback.showDialog()
    },
    // pc端退出登录按钮点击
    pcLogoutClick() {
      this.$refs.logoutDialog.showDialog()
    },
    // 退出登录
    logout() {
      this.memberId = '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9'
      this.$store.dispatch('logout')
    },
    // 初始化微信按钮
    initWxBtns() {
      const _this = this
      try {
        wx.ready(function () {
          wx.hideAllNonBaseMenuItem();
          wx.showMenuItems({
            menuList: ["menuItem:share:appMessage", "menuItem:share:timeline"]
            // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
          });
          const href = window.location.href.substring(0, window.location.href.indexOf('chat-online'))
          // 微信分享给朋友
          if (wx.updateAppMessageShareData) {
            wx.updateAppMessageShareData({
              title: `${_this.meetingDetail.title ? _this.meetingDetail.title : '云直播邀你一起学习啦'}`, //_this.obj.title, // 分享标题
              desc: `${_this.meetingDetail.display_time}`, // 分享描述
              link: href + `entry?live_meeting_id=${_this.$route.query.live_meeting_id}&room=${_this.streamId}` + (_this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9' ? `&memberId=${_this.memberId}` : '') + (_this.$route.query.video_id ? `&video_id=${_this.$route.query.video_id}` : '') + (_this.$route.query.conventionId ? `&conventionId=${_this.$route.query.conventionId}` : ''), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: _this.meetingDetail.detail_cover_url, // 分享图标
              success: function () {
                console.log("分享成功", 2);
                // 设置成功
              },
              fail: function (err) {
                console.log(333, err);
              },
            });
          } else if (wx.onMenuShareAppMessage) {
            wx.onMenuShareAppMessage({
              title: `${_this.meetingDetail.title ? _this.meetingDetail.title : '云直播邀你一起学习啦'}`, //_this.obj.title, // 分享标题
              desc: `${_this.meetingDetail.display_time}`, // 分享描述
              link: href + `entry?live_meeting_id=${_this.$route.query.live_meeting_id}&room=${_this.streamId}` + (_this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9' ? `&memberId=${_this.memberId}` : '') + (_this.$route.query.video_id ? `&video_id=${_this.$route.query.video_id}` : '') + (_this.$route.query.conventionId ? `&conventionId=${_this.$route.query.conventionId}` : ''), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: _this.meetingDetail.detail_cover_url, // 分享图标
              success: function () {
                console.log("分享成功", 2);
                // 设置成功
              },
              fail: function (err) {
                console.log(333, err);
              },
            });
          }
          // 微信分享到朋友圈
          if (wx.updateTimelineShareData) {
            wx.updateTimelineShareData({
              title: `${_this.meetingDetail.title ? _this.meetingDetail.title : '云直播邀你一起学习啦'}`, //_this.obj.title, // 分享标题
              link: href + `entry?live_meeting_id=${_this.$route.query.live_meeting_id}&room=${_this.streamId}` + (_this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9' ? `&memberId=${_this.memberId}` : '') + (_this.$route.query.video_id ? `&video_id=${_this.$route.query.video_id}` : '') + (_this.$route.query.conventionId ? `&conventionId=${_this.$route.query.conventionId}` : ''), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: _this.meetingDetail.detail_cover_url, // 分享图标
              success: function () {
                // 设置成功
                console.log("分享成功", 2);
              },
              fail: function (err) {
                console.log(333, err);
              }
            })
          } else if (wx.onMenuShareTimeline) {
            wx.onMenuShareTimeline({
              title: `${_this.meetingDetail.title ? _this.meetingDetail.title : '云直播邀你一起学习啦'}`, //_this.obj.title, // 分享标题
              link: href + `entry?live_meeting_id=${_this.$route.query.live_meeting_id}&room=${_this.streamId}` + (_this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9' ? `&memberId=${_this.memberId}` : '') + (_this.$route.query.video_id ? `&video_id=${_this.$route.query.video_id}` : '') + (_this.$route.query.conventionId ? `&conventionId=${_this.$route.query.conventionId}` : ''), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: _this.meetingDetail.detail_cover_url, // 分享图标
              success: function () {
                // 设置成功
                console.log("分享成功", 2);
              },
              fail: function (err) {
                console.log(333, err);
              }
            })
          }
        });
      } catch{ }
    },
    // DES加密
    // encryptDes(message, key) {
    //   let keyHex = cryptoJs.enc.Utf8.parse(key)
    //   let option = { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }
    //   let encrypted = cryptoJs.DES.encrypt(message, keyHex, option)
    //   return encrypted.ciphertext.toString()
    // },
  },
}
</script>

<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.chat-container{
  .navbar-p-pc{
    height: 1.33rem;
    width: 100%;
    background-color: #1D1D1D;
    padding-left: 0.36rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navbar-p-pc-l{
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      flex: 1;
      margin-right: 0.5rem;
      .navbar-p-pc-l-title{
        font-size: 0.21rem;
        color: #FFF;
        word-break: break-all;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .navbar-p-pc-l-time{
        font-size: 0.19rem;
        color: #9B9B9B;
        margin-top: 0.12rem;
      }
    }
    .navbar-p-pc-m{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 0.5rem;
    }
    .navbar-p-pc-r{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .navbar-p-pc-r-num{
        margin-right: 0.24rem;
        height: 26px;
      }
      .navbar-p-pc-r-phone{
        margin-right: 0.24rem;
        cursor: pointer;
        .phone-desc{
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.19rem;
          color: #FFF;
          white-space: nowrap;
          .van-icon {
            font-size: 0.25rem;
            color: #fff;
            margin-right: 0.1rem
          }
        }
      }
      .navbar-p-pc-r-tel{
        font-size: 0.19rem;
        color: #FFF;
        margin-right: 0.32rem;
        white-space: nowrap;
        .van-icon {
          font-size: 0.25rem;
          color: #fff;
          margin-right: 0.1rem
        }
      }
      .navbar-p-pc-r-avator{
        display: flex;
        align-items: center;
        margin-right: 0.32rem;
        cursor: pointer;
      }
    }
  }
  .body-pc{
    width: 100%;
    height: calc(100% - 1.33rem);
    background-color: #1D1D1D;
    display: flex;
    align-items: flex-start;
    .body-pc-l{
      width: calc(100% - 6.44rem);
      height: 100%;
      .all {
        width: 100%;
        height: 100%;
        position: relative;
        .all-content {
          width: 100%;
          height: 100%;
        }
        .not-start {
          position: absolute;
          bottom: 0rem;
          left: 0%;
          width: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          // box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.53);
          // border-radius: 2px;
          color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 0.5rem 0rem 0.4rem 0.4rem;
          white-space: nowrap;
          .count-title {
            font-size: 0.3rem;
          }
          .van-count-down {
            font-size: 0.3rem;
            color: #fff;
            display: flex;
            // height: 0.2rem;
            // line-height: 0.22rem;
            // background-color: #879bb9;
            // padding: 0.02rem 0.04rem 0.04rem;
            border-radius: 2px;
            .block-p {
              position: relative;
              .block {
                // background-color: #383838;
                // height: 0.2rem;
                // line-height: 0.22rem;
                padding: 0 0.02rem;
                border-radius: 2px;
              }
              .unit {
                position: absolute;
                right: 0;
                bottom: -0.12rem;
                color: #383838;
                text-align: right;
                transform: scale(0.6);
              }
            }
            .colon {
              color: #fff;
              margin-right: 0.04rem;
              // transform: scale(0.45);
              // transform-origin: 0.05rem 0.16rem;
            }
          }
        }
      }
      .Q-A-panel {
        position: absolute;
        width: 2.9rem;
        // min-height: 0.94rem;
        bottom: -100%;
        right: 6.66rem;
        transition: bottom 1s ease-in-out;
        background-color: RGBA(217, 229, 240, 0.2);
        border-top: 0.03rem solid RGBA(217, 229, 240, 0.2);
        border-left: 0.03rem solid RGBA(217, 229, 240, 0.2);
        border-right: 0.03rem solid RGBA(217, 229, 240, 0.2);
        border-top-left-radius: 0.16rem;
        border-top-right-radius: 0.16rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        .Q-A-p{
          background-color: #fff;
          width: 100%;
          height: 100%;
          padding: 0.14rem 0.08rem 0.14rem;
          border-top-left-radius: 0.16rem;
          border-top-right-radius: 0.16rem;
        }
        .Q-A-close-btn {
          cursor: pointer;
          position: absolute;
          top: -0.15rem;
          right: -0.1rem;
          display: flex;
        }
        .Q-A-body {
          .Q-A-question {
            font-size: 0.19rem;
            font-weight: bold;
            color: #333333;
          }
          .Q-A-answer {
            margin-top: 0.2rem;
            font-size: 0.19rem;
            color: #333333;
            display: flex;
            justify-content: center;
            align-items: center;
            .van-button{
              // width: 0.72rem;
              height: 0.33rem;
              line-height: 0.3rem;
              font-size: 0.19rem;
              padding: 0.05rem 0.1rem 0.03rem;
              color: #2284E5;
              border-color: #2284E5;
              &.active{
                background-color: #2284E5;
                color: #FFF;
              }
            }
            .van-button+.van-button {
              margin-left: 0.16rem;
            }
          }
        }
      }
      .show-my-question {
        bottom: -0.01rem;
      }
    }
    .body-pc-r{
      width: 6.44rem;
      height: 100%;
      .chat-panel-pc {
        width: 100%;
        height: 100%;
        z-index: 1000;
         overflow-x:hidden ;
        .chat-tool-panel {
          height: 0.7rem;
          // border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #1C2127;
          .chat-tool {
            //  width: 33.3%;
            height: 100%;
            font-size: 0.2rem;
            color: #ADB4BB;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
          .active {
            position: relative;
            color: #ADB4BB;
            font-weight: bold;
            &::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 0.67rem;
              height: 0.05rem;
              background-color: #56B7F9;
              border-radius: 0.03rem;
            }
          }
        }
        .chat-p-panel {
          height: calc(100% - 0.7rem);
          display: flex;
          transition: all 0.5s;
          .chat-syllabus {
            // width: 50%;
            height: 100%;
            padding: 0.16rem 0.1rem 0;
            // display: flex;
            // justify-content: center;
            overflow-y: auto;
            img {
              width: 100%;
              // max-height: 100%;
            }
          }
          .chat-duration {
            height: 100%;
            overflow-y: auto;
          }
          .chat-content {
            height: 100%;
            // overflow-y: auto;
          }
          .chat-backplay {
            height: 100%;
            overflow-y: auto;
            padding: 0.21rem 0.21rem 0;
            .backplay-item {
              font-size: 0.21rem;
              color: #C7C7C7;
              margin-bottom: 0.21rem;
              display: flex;
              .van-icon {
                margin-right: 0.15rem;
                padding-top: 0.03rem;
              }
              .backplay-title {
                flex-grow: 1;
              }
            }
            .active {
              color: #56B7F9;
            }
          }
          .chat-p {
            //  width: 50%;
            height: 100%;
            .chat-list {
              height: calc(100% - 0.61rem);
            }
            .chat-input {
              height: 0.61rem;
              padding: 0.07rem 0 0.07rem 0.16rem;
              display: flex;
              align-items: center;
              .van-search {
                width: 100%;
                padding: 0;
                .van-search__content {
                  background-color: #fff;
                  border: 1px solid #959595;
                }
              }
              .van-icon {
                font-size: 0.45rem;
                color: #959595;
                margin-right: 0.16rem;
                &:first-of-type {
                  margin-left: 0.16rem;
                }
              }
              .add-btn {
                width: 0.89rem;
                height: 0.4rem;
                padding: 0;
                margin-left: 0.16rem;
                margin-right: 0.16rem;
              }
            }
          }
          .chat-cloudHall {
            padding: 0 0.3rem 0.16rem;
            // background-color: #f4f4f4;
            height: 100%;
            overflow-y: auto;
            .cloudHall-item {
              width: 100%;
              margin-top: 0.16rem;
              img {
                width: 100%;
                height: 1.55rem;
                vertical-align: top;
              }
              .title {
                width: 100%;
                height: 0.5rem;
                line-height: 0.5rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 0.2rem;
                color: #FFF;
                text-align: center;
                // background-color: #dbdbdb;
              }
            }
          }
          .chat-enterprise {
            height: 100%;
            padding: 0.08rem 0.1rem;
            overflow-y: auto;
            position: absolute; //不加这个 图片会滑到最左边  被遮挡
            top:0;
            right: 0;
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .customize-absolute-p-pc {
    width: 1.05rem;
    text-align: center;
    display: flex;
    .van-image{
      cursor: pointer;
    }
  }
  .logperfect-absolute-p-pc {
    width: 1.05rem;
    text-align: center;
    display: flex;
    .van-image{
      cursor: pointer;
    }
  }
  .appoint-absolute-p-pc {
    width: 1.05rem;
    text-align: center;
    display: flex;
    padding-top: 0.2rem;
    .van-image{
      cursor: pointer;
    }
  }
}
.chat-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-bottom: env(safe-area-inset-bottom);
  .navbar-p {
    width: 100%;
    height: 0.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #2284E5;
    .left-btn {
      width: 1.5rem;
      height: 100%;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 0.2rem;
      padding-left: 0.2rem;
      .van-icon {
        margin-right: 0.1rem;
      }
    }
    .right-btn {
      width: 1rem;
      height: 100%;
      padding-right: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
  .online-link {
    position: relative;
    width: 100%;
    height: 2.81rem;
    z-index: 1750;
    overflow: hidden;
    // background-color: blue;
    .all {
      width: 100%;
      height: 100%;
      position: relative;
      .all-content {
        width: 100%;
        height: 100%;
      }
      .not-start {
        position: absolute;
        bottom: 0rem;
        left: 0%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        // box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.53);
        // border-radius: 2px;
        color: #fff;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0.08rem 0rem 0.08rem 0.23rem;
        white-space: nowrap;
        .count-title {
          font-size: 0.19rem;
        }
        .van-count-down {
          font-size: 0.19rem;
          color: #fff;
          display: flex;
          // height: 0.2rem;
          // line-height: 0.22rem;
          // background-color: #879bb9;
          // padding: 0.02rem 0.04rem 0.04rem;
          border-radius: 2px;
          .block-p {
            position: relative;
            .block {
              // background-color: #383838;
              // height: 0.2rem;
              // line-height: 0.22rem;
              padding: 0 0.02rem;
              border-radius: 2px;
            }
            .unit {
              position: absolute;
              right: 0;
              bottom: -0.12rem;
              color: #383838;
              text-align: right;
              transform: scale(0.6);
            }
          }
          .colon {
            color: #fff;
            margin-right: 0.04rem;
            // transform: scale(0.45);
            // transform-origin: 0.05rem 0.16rem;
          }
        }
      }
    }
    .Q-A-panel {
      position: absolute;
      width: 1.9rem;
      // min-height: 0.94rem;
      bottom: -100%;
      right: 0.22rem;
      transition: bottom 1s ease-in-out;
      background-color: RGBA(217, 229, 240, 0.2);
      border-top: 0.03rem solid RGBA(217, 229, 240, 0.2);
      border-left: 0.03rem solid RGBA(217, 229, 240, 0.2);
      border-right: 0.03rem solid RGBA(217, 229, 240, 0.2);
      border-top-left-radius: 0.16rem;
      border-top-right-radius: 0.16rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      .Q-A-p{
        background-color: #fff;
        width: 100%;
        height: 100%;
        padding: 0.14rem 0.08rem 0.14rem;
        border-top-left-radius: 0.16rem;
        border-top-right-radius: 0.16rem;
      }
      .Q-A-close-btn {
        cursor: pointer;
        position: absolute;
        top: -0.15rem;
        right: -0.1rem;
        display: flex;
      }
      .Q-A-body {
        .Q-A-question {
          font-size: 0.13rem;
          font-weight: bold;
          color: #333333;
        }
        .Q-A-answer {
          margin-top: 0.1rem;
          font-size: 0.19rem;
          color: #333333;
          display: flex;
          justify-content: center;
          align-items: center;
          .van-button{
            // width: 0.72rem;
            height: 0.23rem;
            line-height: 0.2rem;
            font-size: 0.11rem;
            padding: 0.05rem 0.1rem 0.03rem;
            color: #2284E5;
            border-color: #2284E5;
            &.active{
              background-color: #2284E5;
              color: #FFF;
            }
          }
          .van-button+.van-button {
            margin-left: 0.08rem;
          }
        }
      }
    }
    .show-my-question {
      bottom: -0.01rem;
    }
  }
  .history-contain {
    height: 0.62rem;
    width: 100%;
    overflow-x: auto;
    .history-panel {
      // width: 100%;
      height: 100%;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      display: inline-flex;
      padding: 0.12rem 0;
      .history-item {
        margin: 0 0.1rem;
        height: 0.38rem;
        min-width: 1rem;
        background-color: #fff;
        border: 1px solid #2284E5;
        border-radius: 4px;
        color: #2284E5;
        font-size: 0.17rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .van-icon {
          margin-left: 0.08rem;
          font-size: 0.23rem;
        }
        .his-desc {
          margin-left: 0.05rem;
        }
      }
      .active {
        background-color: #2284E5;
        border: 1px solid #2284E5;
        color: #fff;
      }
    }
    .history-empty {
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 0.62rem;
      color: #000;
      font-size: 0.17rem;
    }
  }
  .room-info-panel {
    padding: 0.2rem 0.2rem 0.17rem;
    border-bottom: 1px solid #eeeff2;
    .room-info-title {
      font-size: 0.21rem;
      font-weight: bold;
      color: #333333;
      margin-bottom: 0.13rem;
    }
    .room-info-other {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .room-other-time {
        font-size: 0.19rem;
        font-weight: bold;
        color: #9b9b9b;
      }
      .room-other-online {
      }
    }
  }
  .chat-panel {
    width: 100%;
    z-index: 1500;
    position: relative;
    .chat-tool-panel {
      height: 0.58rem;
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .chat-tool {
        // width: 33.3%;
        height: 100%;
        font-size: 0.2rem;
        color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .active {
        color: #2284E5;
        font-weight: bold;
      }
    }
    .chat-p-panel {
      height: calc(100% - 0.58rem);
      display: flex;
      transition: all 0.5s;
      
      .chat-syllabus {
        // width: 50%;
        height: 100%;
        padding: 0.16rem 0.1rem 0;
        // display: flex;
        // justify-content: center;
        overflow-y: auto;
        img {
          width: 100%;
          // max-height: 100%;
        }
      }
      .chat-duration {
        height: 100%;
        overflow-y: auto;
      }
      .chat-content {
        height: 100%;
        // overflow-y: auto;
      }
      .chat-backplay {
        height: 100%;
        overflow-y: auto;
        padding: 0.21rem 0.21rem 0;
        .backplay-item {
          font-size: 0.21rem;
          color: #393939;
          margin-bottom: 0.21rem;
          display: flex;
          .van-icon {
            margin-right: 0.15rem;
            padding-top: 0.03rem;
          }
          .backplay-title {
            flex-grow: 1;
          }
        }
        .active {
          color: #2284E5;
        }
      }
      .chat-p {
        // width: 50%;
        height: 100%;
        .chat-list {
          height: calc(100% - 2.61rem);
        }
        .chat-input-p{
          position: absolute;
          // bottom: 0;
          bottom: 0;
          width: 5rem;
          background-color: #fff;
          z-index: 1500;
          border-top: 1px solid #f0f0f0;
          .chat-avatar {
            margin-right: 0.12rem;
            /deep/.van-image__loading-icon{
              font-size: 0.25rem;
            }
          }
          .chat-input {
            min-height: 0.61rem;
            padding: 0.07rem 0 0.07rem 0.16rem;
            display: flex;
            align-items: flex-end;
            .van-search {
              width: 100%;
              padding: 0;
              .van-search__content {
                background-color: #fff;
                border: 1px solid #959595;
              }
            }
            .custom-input{
              width: 100%;
              position: relative;
              max-height: 0.96rem;
              min-height: 0.48rem;
              overflow-y: auto;
              line-height: 0.48rem;
              // outline: #D3D3D3 auto 1px;
              padding-left: 1px;
              // &:focus-visible {
              //   // outline: -webkit-focus-ring-color auto 1px;
              //   outline: #D3D3D3 auto 1px;
              // }
              // &:empty::before {
              //   content: attr(placeholder);
              //   font-size: 14px;
              //   color: #CCC;
              //   line-height: 21px;
              //   padding-top: 20px;
              // }
            }
            /* 四周边框 */
            .custom-input:before {
              content: "";
              width: 100%;
              height: 100%;
              border: 1px solid #D3D3D3;
              position: absolute;
              left: 0;
              top: 0;
              box-sizing: border-box;
              transform-origin: top left;
              -webkit-transform-origin: top left;
            }
            @media screen and(-webkit-min-device-pixel-ratio:2) {
              .custom-input:before {
                width: 200%;
                height: 200%;
                transform: scale(0.5);
                -webkit-transform: scale(0.5);
              }
            }
            @media screen and(-webkit-min-device-pixel-ratio:3) {
              .custom-input:before {
                width: 300%;
                height: 300%;
                transform: scale(0.3333);
                -webkit-transform: scale(0.3333);
              }
            }
            .van-icon {
              font-size: 0.45rem;
              color: #959595;
              margin-right: 0.12rem;
              cursor: pointer;
              &:first-of-type {
                margin-left: 0.12rem;
              }
            }
            .add-btn {
              width: 0.89rem;
              height: 0.45rem;
              padding: 0;
              // margin-left: 0.16rem;
              margin-right: 0.16rem;
            }
          }
          .emoji-list-p{
            position: relative;
            height: 2.5rem;
            overflow-y: auto;
            .emoji-list{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-wrap: wrap;
              padding: 0.08rem;
              height: 100%;
              overflow-y: auto;
              .emoji-item{
                font-size: 0.3rem;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                user-select: none;
              }
            }
            .remove-p{
              position: absolute;
              bottom: 0;
              text-align: right;
              padding-right: 0.22rem;
              background-color: #FFF;
            }
          }
        }
      }
      .chat-cloudHall {
        padding: 0 0.15rem 0.08rem;
        background-color: #f4f4f4;
        height: 100%;
        overflow-y: auto;
        .cloudHall-item {
          width: 100%;
          margin-top: 0.08rem;
          img {
            width: 100%;
            height: 1.26rem;
            vertical-align: top;
          }
          .title {
            width: 100%;
            height: 0.4rem;
            line-height: 0.4rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 0.2rem;
            color: #333333;
            background-color: #dbdbdb;
          }
        }
      }
      .chat-enterprise {
        height: 100%;
    
        padding: 0.08rem 0.1rem;
        overflow-y: auto;

       ;
        img {
          width: 100%;
        }
      }
    }
  }
  .absolute-p {
    display: none;
    position: absolute;
    right: 0.18rem;
    bottom: calc(calc(env(safe-area-inset-bottom)) + 0.51rem);
    z-index: 1700;
  }
  .customize-absolute-p {
    position: absolute;
    right: 0.18rem;
    bottom: calc(calc(env(safe-area-inset-bottom)) + 1.65rem);
    width: 0.8rem;
    text-align: center;
    z-index: 1700;
    .van-image{
      cursor: pointer;
    }
  }
  .logperfect-absolute-p {
    position: absolute;
    right: 0.18rem;
    bottom: calc(calc(env(safe-area-inset-bottom)) + 1.65rem);
    width: 0.8rem;
    text-align: center;
    z-index: 1700;
    .van-image{
      cursor: pointer;
    }
  }
  .appoint-absolute-p {
    position: absolute;
    right: 0.18rem;
    bottom: calc(calc(env(safe-area-inset-bottom)) + 1.55rem);
    width: 0.8rem;
    text-align: center;
    z-index: 1700;
    .van-image{
      cursor: pointer;
    }
  }
  .share-popup {
    width: 4.2rem;
    left: 50%;
    height: 4.17rem;
    // transform: translateX(-2.1rem);
    margin-left: -2.1rem;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    .share-p {
      display: flex;
      flex-direction: column;
      align-items: center;
      .share-title {
        margin: 0.55rem 0 0.25rem;
        text-align: center;
        color: #fff;
        font-size: 0.25rem;
      }
    }
  }
}
.van-dialog {
  border-radius: 6px;
}
.login-popup-pc {
  width: 6.44rem;
  height: 1.8rem;
  right: 0;
  left: auto;
  background-color: #504d50;
  .login-popup-p {
    display: flex;
    width: 5.24rem;
    height: 0.75rem;
    margin: 0.56rem auto 0;
    padding: 0 0.33rem;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    border-radius: 12px;
    .login-tip {
      font-size: 0.2rem;
      color: #000;
    }
    .login-btn {
      width: 1.05rem;
      height: 0.47rem;
      background: #2284E5;
      padding: 0;
      font-size: 0.2rem;
    }
  }
  .van-popup__close-icon{
    font-size: 0.35rem;
  }
}
.login-content {
  height: 3.7rem;
  padding: 0 0.25rem;
  .title {
    font-size: 0.23rem;
    color: #131313;
    font-weight: bold;
    text-align: center;
    margin-top: 0.33rem;
    margin-bottom: 0.5rem;
  }
  .van-cell {
    margin-top: 0.1rem;
    padding: 0.13333rem 0;
  }
  .loginBtn {
    width: 2.8rem;
    height: 0.45rem;
    margin: 0.45rem auto 0.65rem;
    display: block;
  }
}
.perfect-content {
  // height: 4.5rem;
  padding: 0 0.25rem;
  .title {
    font-size: 0.23rem;
    color: #131313;
    font-weight: bold;
    text-align: center;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }
  .van-cell {
    // margin-top: 0.1rem;
    padding: 0.13333rem 0;
  }
  .perfectBtn {
    width: 2.8rem;
    height: 0.45rem;
    margin: 0.25rem auto 0.45rem;
    display: block;
  }
}
.policy-content {
  padding: 0 0.25rem;
  .title {
    font-size: 0.23rem;
    color: #131313;
    font-weight: bold;
    text-align: center;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }
  .policy-p {
    max-height: 3.67rem;
    overflow-y: auto;
    font-size: 0.15rem;
    color: #666666;
    line-height: 0.25rem;
    /deep/pre {
      white-space: pre-wrap;
      margin: 0;
    }
  }
  .policy-check {
    margin-top: 0.05rem;
  }
  /deep/.van-checkbox__label {
    font-size: 0.16rem;
  }
  .policyBtn {
    width: 2.8rem;
    height: 0.45rem;
    margin: 0.15rem auto 0.25rem;
    display: block;
  }
}
.login-popup {
  width: 100%;
  height: 1.8rem;
  background-color: #504d50;
  .login-popup-p {
    display: flex;
    width: 4.24rem;
    height: 0.55rem;
    margin: 0.66rem auto 0;
    padding: 0 0.33rem;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    border-radius: 12px;
    .login-tip {
      font-size: 0.16rem;
      color: #000;
    }
    .login-btn {
      width: 0.95rem;
      height: 0.37rem;
      background: #2284E5;
      padding: 0;
    }
  }
}
/deep/.van-popup{
  position: absolute;
}
.feedback-popup-p{
  padding: 0.21rem 0.16rem 0;
  .feedback-title{
    font-size: 0.24rem;
    color: #333333;
    padding-bottom: 0.25rem;
    border-bottom: 2px solid #CAD1D9;
    font-weight: 400;
  }
  .feedback-body{
    padding: 0.27rem 0 0.48rem 0.13rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 2px solid #CAD1D9;
    .feedback-item{
      margin-right: 0.4rem;
      cursor: pointer;
      .feedback-item-img-p{
        width: 0.8rem;
        height: 0.8rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.07rem;
        background-color: #FFF;
        .feedback-item-img{
          width: 0.43rem;
          height: 0.43rem;
        }
      }
      .feedback-item-desc{
        margin-top: 0.08rem;
        font-size: 0.16rem;
        color: #333333;
        text-align: center;
      }
    }
  }
  .feedback-cancel{
    padding: 0.3rem 0;
    text-align: center;
    font-size: 0.24rem;
    color: #333333;
    cursor: pointer;
  }
}
</style>
